(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[745],{

/***/ 17368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_NoSsr__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58769);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76480);







// thuannc
// TODO:
// MUST FIX
function MobileCountdownTimer(_param) {
    var prefix = _param.prefix, dealEndDay = _param.dealEndDay, translateCommon = _param.translateCommon, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "prefix",
        "dealEndDay",
        "translateCommon"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((0,utils__WEBPACK_IMPORTED_MODULE_2__/* .calculateTimeLeft */ .VZ)(dealEndDay)), timeLeft = ref[0], setTimeLeft = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var timer = setTimeout(function() {
            setTimeLeft((0,utils__WEBPACK_IMPORTED_MODULE_2__/* .calculateTimeLeft */ .VZ)(dealEndDay));
        }, 1000);
        return function() {
            return clearTimeout(timer);
        };
    });
    var timerComponents = [];
    Object.keys(timeLeft).forEach(function(interval) {
        var val = timeLeft[interval];
        if (!val) {
            return;
        }
        // 05Jan2022 -> nếu > 30 ngày thì set lại 30 ngày, dài quá bể UI
        /**
     *  bổ sung rules cho UI mobile v2
     *  + countdown có thêm ngày -> chia 2 dòng 1 dòng ngày 1 dòng giờ:phút:giây
     *  + countdown không có ngày -> 1 dòng giờ:phút:giây
     */ // 28Sep2023: product card v5.1 -> count down is one line
        var Tag = "span";
        // if (interval === 'days') Tag = 'div';
        timerComponents.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Tag, {
            style: interval === "days" ? {
                marginRight: "4px"
            } : {},
            children: [
                val,
                interval === "days" ? " ".concat(translateCommon("days")) : null
            ]
        }, "timer-".concat(Math.random())));
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_NoSsr__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, otherProps), {
            children: [
                prefix,
                " ",
                timerComponents.length ? timerComponents : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    children: translateCommon("voucher.end_of_promotion")
                })
            ]
        }))
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (MobileCountdownTimer);


/***/ }),

/***/ 27890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Input__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38799);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26380);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_6__);
/* eslint-disable func-names */ 






var NewInputProduct = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(_param) /*#__PURE__*/ {
    var className = _param.className, name = _param.name, searchInput = _param.searchInput, defaultValue = _param.defaultValue, _onChange = _param.onChange, onChange = _onChange === void 0 ? function() {} : _onChange, value = _param.value, product = _param.product, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _onBlur = _param.onBlur, onBlur = _onBlur === void 0 ? function() {} : _onBlur, _onKeyDown = _param.onKeyDown, onKeyDown = _onKeyDown === void 0 ? function() {} : _onKeyDown, _onFocus = _param.onFocus, onFocus = _onFocus === void 0 ? function() {} : _onFocus, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className",
        "name",
        "searchInput",
        "defaultValue",
        "onChange",
        "value",
        "product",
        "disabled",
        "onBlur",
        "onKeyDown",
        "onFocus"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Input__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        type: "text",
        min: "0",
        step: "1",
        pattern: "\\d*",
        name: name,
        inputRef: searchInput,
        classes: {
            root: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().root_input), className),
            input: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().input),
            focused: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().focus)
        },
        disableUnderline: true,
        placeholder: "0",
        onChange: function(e) {
            return onChange(e, product);
        },
        onBlur: function(e) {
            return onBlur(e, product);
        },
        onKeyDown: function(e) {
            return onKeyDown(e, product);
        },
        value: value,
        defaultValue: defaultValue,
        disabled: disabled,
        onFocus: onFocus
    }, restProps));
});
/* harmony default export */ __webpack_exports__["Z"] = (NewInputProduct);


/***/ }),

/***/ 30851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(282);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5007);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_7__);








var NewMinusButton = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(_param) /*#__PURE__*/ {
    var className = _param.className, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, restProps), {
            classes: {
                root: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().buttons), (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().button_root_minus))
            },
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().button_minus), className),
            children: "-"
        }))
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (NewMinusButton);


/***/ }),

/***/ 92959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(282);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5007);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_7__);








var NewPlusButton = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(_param) /*#__PURE__*/ {
    var className = _param.className, disabled = _param.disabled, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className",
        "disabled"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, restProps), {
            disabled: disabled,
            classes: {
                root: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().buttons), disabled ? ((_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().plus_disabled), (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().button_plus)) : (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().button_plus), className)
            },
            children: "+"
        }))
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (NewPlusButton);


/***/ }),

/***/ 72640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_NoSsr__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58769);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76480);







// thuannc
// TODO:
// MUST FIX
function CountdownTimer(_param) {
    var prefix = _param.prefix, dealEndDay = _param.dealEndDay, translateCommon = _param.translateCommon, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "prefix",
        "dealEndDay",
        "translateCommon"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((0,utils__WEBPACK_IMPORTED_MODULE_2__/* .calculateTimeLeft */ .VZ)(dealEndDay)), timeLeft = ref[0], setTimeLeft = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var timer = setTimeout(function() {
            setTimeLeft((0,utils__WEBPACK_IMPORTED_MODULE_2__/* .calculateTimeLeft */ .VZ)(dealEndDay));
        }, 1000);
        return function() {
            return clearTimeout(timer);
        };
    });
    var timerComponents = [];
    Object.keys(timeLeft).forEach(function(interval) {
        var val = timeLeft[interval];
        if (!val) {
            return;
        }
        // 05Jan2022 -> nếu > 30 ngày thì set lại 30 ngày, dài quá bể UI
        timerComponents.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            style: interval === "days" ? {
                marginRight: "4px"
            } : {},
            children: [
                val,
                interval === "days" ? " ".concat(translateCommon("days"), " ") : null
            ]
        }, "timer-".concat(Math.random())));
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_NoSsr__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, otherProps), {
            children: [
                prefix,
                " ",
                timerComponents.length ? timerComponents : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    children: translateCommon("voucher.end_of_promotion")
                })
            ]
        }))
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (CountdownTimer);


/***/ }),

/***/ 77524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mocules_ProductCardInput; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 12 modules
var Box = __webpack_require__(80343);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CardActions/CardActions.js
var CardActions = __webpack_require__(51907);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CardContent/CardContent.js
var CardContent = __webpack_require__(79912);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(868);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/TrendingDown.js
var TrendingDown = __webpack_require__(15527);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/TrendingUp.js
var TrendingUp = __webpack_require__(84618);
// EXTERNAL MODULE: ./src/clients/index.js + 20 modules
var clients = __webpack_require__(15149);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/components/atoms/index.js + 15 modules
var atoms = __webpack_require__(53316);
// EXTERNAL MODULE: ./src/components/atoms/NewInputProduct/index.js
var NewInputProduct = __webpack_require__(27890);
// EXTERNAL MODULE: ./src/components/atoms/QuantityButton/NewMinusButton.js
var NewMinusButton = __webpack_require__(30851);
// EXTERNAL MODULE: ./src/components/atoms/QuantityButton/NewPlusButton.js
var NewPlusButton = __webpack_require__(92959);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/LinearProgress/LinearProgress.js
var LinearProgress = __webpack_require__(33681);
// EXTERNAL MODULE: ./src/components-v2/mocules/mobile/CountdownTimer/index.js
var CountdownTimer = __webpack_require__(17368);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 6 modules
var esm = __webpack_require__(5233);
// EXTERNAL MODULE: ./src/utils/FormatDate.js
var FormatDate = __webpack_require__(45901);
// EXTERNAL MODULE: ./src/zustand-lib/storeMobile.js
var storeMobile = __webpack_require__(35810);
// EXTERNAL MODULE: ./src/components/mocules/CountdownTimer/index.js
var mocules_CountdownTimer = __webpack_require__(72640);
// EXTERNAL MODULE: ./src/components/mocules/DealSectionNew/styles.module.css
var styles_module = __webpack_require__(67364);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/DealSectionNew/index.js
/* eslint-disable no-nested-ternary */ 











var DealSectionNew = function(param) {
    var dealEndDay = param.dealEndDay, dealReady = param.dealReady, dealStartTime = param.dealStartTime, _totalSold = param.totalSold, totalSold = _totalSold === void 0 ? 0 : _totalSold, _isHappeningCampaign = param.isHappeningCampaign, isHappeningCampaign = _isHappeningCampaign === void 0 ? false : _isHappeningCampaign, _percentDealSold = param.percentDealSold, percentDealSold = _percentDealSold === void 0 ? 0 : _percentDealSold;
    var ref = (0,esm/* useTranslation */.$G)("common"), translateCommon = ref.t;
    var startDate = (0,FormatDate/* formatDate */.p6)(dealStartTime);
    var isMobileV2 = (0,storeMobile/* default */.Z)(function(state) {
        return state.isMobileV2();
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
        container: true,
        spacing: isMobileV2 ? 0 : 1,
        className: (0,clsx_m/* default */.Z)((styles_module_default()).deal_section, (0,_define_property/* default */.Z)({}, (styles_module_default()).deal_section_mv2, isMobileV2)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                item: true,
                xs: isMobileV2 ? dealReady ? 12 : 8 : 12,
                className: (0,clsx_m/* default */.Z)((styles_module_default()).process_wrapper, (0,_define_property/* default */.Z)({}, (styles_module_default()).process_wrapper_mv2, isMobileV2)),
                children: isHappeningCampaign && dealReady && percentDealSold === 100 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LinearProgress/* default */.Z, {
                            classes: {
                                root: (0,clsx_m/* default */.Z)((styles_module_default()).root_process, isMobileV2 && (styles_module_default()).root_process_mv2),
                                barColorPrimary: (styles_module_default()).bar_background,
                                colorPrimary: (styles_module_default()).blur_background
                            },
                            variant: "determinate",
                            value: percentDealSold
                        }),
                        !isHappeningCampaign && dealReady && percentDealSold === 100 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (styles_module_default()).process_content,
                            children: translateCommon("deal.sold_out")
                        }),
                        dealReady && percentDealSold < 75 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (styles_module_default()).process_content,
                            children: "".concat(translateCommon("deal.sold"), " ").concat(totalSold)
                        }),
                        !dealReady && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (styles_module_default()).process_content,
                            children: translateCommon("deal.on_sale_soon")
                        }),
                        dealReady && percentDealSold >= 75 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (styles_module_default()).process_content,
                            children: translateCommon("deal.out_of_stock_soon")
                        })
                    ]
                })
            }),
            isHappeningCampaign && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) || dealReady && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                xs: isMobileV2 ? 4 : 12,
                item: true,
                className: (styles_module_default()).count_down_container,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    className: (0,clsx_m/* default */.Z)(isMobileV2 && (styles_module_default()).countdown_timer_mv2),
                    item: true,
                    children: isMobileV2 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CountdownTimer/* default */.Z, {
                        translateCommon: translateCommon,
                        className: (styles_module_default()).count_down,
                        dealEndDay: dealEndDay
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_CountdownTimer/* default */.Z, {
                        translateCommon: translateCommon,
                        className: (styles_module_default()).count_down,
                        dealEndDay: dealEndDay
                    })
                })
            }) || !dealReady && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                item: true,
                className: (0,clsx_m/* default */.Z)((styles_module_default()).startDate, (0,_define_property/* default */.Z)({}, (styles_module_default()).startDate_mv2, isMobileV2)),
                children: startDate
            })
        ]
    });
};
/* harmony default export */ var mocules_DealSectionNew = (DealSectionNew);

// EXTERNAL MODULE: ./src/components/organisms/RemoveProductModal/index.js + 1 modules
var RemoveProductModal = __webpack_require__(39796);
// EXTERNAL MODULE: ./src/constants/ErrorCart/index.js
var ErrorCart = __webpack_require__(83084);
// EXTERNAL MODULE: ./src/constants/Icons/index.js
var Icons = __webpack_require__(43004);
// EXTERNAL MODULE: ./src/constants/data/index.js
var data = __webpack_require__(66520);
// EXTERNAL MODULE: ./src/context/index.js + 10 modules
var context = __webpack_require__(33436);
// EXTERNAL MODULE: ./src/hooks/useModal.js
var useModal = __webpack_require__(16028);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/sysconfig/index.js
var sysconfig = __webpack_require__(66225);
// EXTERNAL MODULE: ./src/utils/index.js + 5 modules
var utils = __webpack_require__(76480);
// EXTERNAL MODULE: ./src/utils/FormatNumber.js
var FormatNumber = __webpack_require__(44097);
// EXTERNAL MODULE: ./src/utils/StringUtils.js
var StringUtils = __webpack_require__(52380);
// EXTERNAL MODULE: ./src/utils/debounce.js
var debounce = __webpack_require__(74118);
// EXTERNAL MODULE: ./src/components/mocules/ProductCardInput/styles.module.css
var ProductCardInput_styles_module = __webpack_require__(29606);
var ProductCardInput_styles_module_default = /*#__PURE__*/__webpack_require__.n(ProductCardInput_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/ProductCardInput/index.js
/* eslint-disable no-nested-ternary */ /* eslint-disable react-hooks/rules-of-hooks */ /* eslint-disable no-else-return */ 



































// CURRENCY_SEPARATE dùng cho String.replace nên có thể chứa '$&', bỏ đi để nối chuỗi trực tiếp
var PRICE_SEPARATOR = (sysconfig/* CURRENCY_SEPARATE */.UI || ",").replace("$&", "");
var ProductCardInput = function(param) {
    var productMaxQuantity = param.maxQuantity, noSupportDelivery = param.not_support_delivery, _salePrice = param.salePrice, salePrice = _salePrice === void 0 ? 0 : _salePrice, _displayPrice = param.displayPrice, displayPrice = _displayPrice === void 0 ? 0 : _displayPrice, _isDeal = param.isDeal, isDeal = _isDeal === void 0 ? false : _isDeal, _deal = param.deal, deal = _deal === void 0 ? {} : _deal, row = param.row, type = param.type, searchInput = param.searchInput, cart = param.cart, productId = param.productId, name = param.name, product = param.product, isMobile = param.isMobile, cartItems = param.cartItems, scrollTo = param.scrollTo, _errorCode = param.errorCode, errorCode = _errorCode === void 0 ? null : _errorCode, _errorMessage = param.errorMessage, errorMessage = _errorMessage === void 0 ? null : _errorMessage, status = param.status, _errorMessageProduct = param.errorMessageProduct, errorMessageProduct = _errorMessageProduct === void 0 ? null : _errorMessageProduct, index = param.index, currentPrice = param.currentPrice, _wishlist = param.wishlist, wishlist = _wishlist === void 0 ? false : _wishlist, handleDelete = param.handleDelete, _isCampaign = param.// unit,
    isCampaign, isCampaign = _isCampaign === void 0 ? false : _isCampaign, productType = param.productType, _isHappeningCampaign = param.isHappeningCampaign, isHappeningCampaign = _isHappeningCampaign === void 0 ? false : _isHappeningCampaign, campaign = param.campaign, availableProducts = param.availableProducts, salePriceFormated = param.salePriceFormated, displayPriceFormated = param.displayPriceFormated, _isSellerList = param.isSellerList, isSellerList = _isSellerList === void 0 ? false : _isSellerList, _isHalfProgress = param.isHalfProgress, isHalfProgress = _isHalfProgress === void 0 ? false : _isHalfProgress, _percentDealSold = param.percentDealSold, percentDealSold = _percentDealSold === void 0 ? 0 : _percentDealSold, _isCampaignPage = param.isCampaignPage, isCampaignPage = _isCampaignPage === void 0 ? false : _isCampaignPage, messageLimitOrder = param.messageLimitOrder, sku = param.sku, _discountPercent = param.discountPercent, discountPercent = _discountPercent === void 0 ? 0 : _discountPercent, isContractPrice = param.isContractPrice;
    var GetPrice = function GetPrice() {
        // BV-1586: giá sau ưu đãi (deal + chiết khấu thanh toán + voucher), giá gạch = giá niêm yết.
        // PLP không có popover. Trang campaign đang che giá (???) thì giữ như cũ.
        if (isShowPriceAfterDiscount && !wishlist && !cart && !(isCampaign && !isHappeningCampaign && isCampaignPage)) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                container: true,
                spacing: 1,
                alignItems: "center",
                className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).displayPrice_wrapper, isMobile && (ProductCardInput_styles_module_default()).wrap, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).displayPrice_wrapper_mv2, isMobileV2)),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        style: {
                            padding: "0",
                            width: isMobile && !beta ? "100%" : "auto"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).display_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).display_price_mv2, isMobileV2)),
                            "data-test": "price-after-discount",
                            children: priceAfterDiscountFormated
                        })
                    }),
                    originPriceFormated && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        style: {
                            padding: "0",
                            paddingLeft: "10px",
                            width: isMobile && !beta ? "100%" : "auto"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).sale_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).sale_price_mv2, isMobileV2)),
                            children: originPriceFormated
                        })
                    })
                ]
            });
        }
        // wishlist page v2
        if (wishlist) {
            // khuyến mãi
            if (isDeal && deal || isCampaign && percentDealSold < 100) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        container: true,
                        spacing: 1,
                        alignItems: "center",
                        className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).display_wishlist_price_wrapper, isMobile && (ProductCardInput_styles_module_default()).wrap, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).displayPrice_wrapper_mv2, isMobileV2)),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    isContractPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContractPrice, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (0,clsx_m/* default */.Z)(isMobile ? (ProductCardInput_styles_module_default()).discount_percent_v2 : (ProductCardInput_styles_module_default()).discount_percent, discountPercent === 0 && (ProductCardInput_styles_module_default()).hidden),
                                        children: "-".concat(discountPercent, "%")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).sale_price, isMobile && (ProductCardInput_styles_module_default()).fs_12, salePriceFormated === displayPriceFormated && (ProductCardInput_styles_module_default()).hidden),
                                        children: salePriceFormated
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                item: true,
                                style: {
                                    padding: "0",
                                    width: isMobile && !beta ? "100%" : "auto"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).display_price, isMobile && (ProductCardInput_styles_module_default()).fs_12),
                                    children: displayPriceFormated
                                })
                            })
                        ]
                    })
                });
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: row ? (ProductCardInput_styles_module_default()).price_wrapper : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).price_wrapper, (ProductCardInput_styles_module_default()).price_wrapper_column),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        container: true,
                        alignItems: "stretch",
                        className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).wishlist_price_wrapper, isMobile && (ProductCardInput_styles_module_default()).wrap, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).displayPrice_wrapper_mv2, isMobileV2), !isMobile && (ProductCardInput_styles_module_default()).pt_55),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                item: true,
                                style: {
                                    paddingLeft: "0",
                                    width: isMobile && !beta ? "100%" : "auto"
                                },
                                children: [
                                    isContractPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContractPrice, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).display_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).display_price_mv2, isMobileV2)),
                                        children: displayPriceFormated
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                item: true,
                                children: [
                                    errorCode === ErrorCart/* ERROR_CODE_CART.CHANGED_PRICE */.M5.CHANGED_PRICE && currentPrice > displayPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendingDown/* default */.Z, {
                                        className: (ProductCardInput_styles_module_default()).down
                                    }),
                                    errorCode === ErrorCart/* ERROR_CODE_CART.CHANGED_PRICE */.M5.CHANGED_PRICE && currentPrice < displayPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendingUp/* default */.Z, {
                                        className: (ProductCardInput_styles_module_default()).up
                                    })
                                ]
                            })
                        ]
                    }),
                    isDeal && deal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        style: {
                            width: isMobile && !beta ? "100%" : "auto"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).sale_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).sale_price_mv2, isMobileV2)),
                            children: salePriceFormated
                        })
                    })
                ]
            });
        }
        if (isSellerList) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ProductCardInput_styles_module_default()).salePrice_wrapper,
                        children: [
                            isHappeningCampaign && salePrice && percentDealSold < 100 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).sale_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).sale_price_mv2, isMobileV2)),
                                children: salePriceFormated
                            }),
                            !isHappeningCampaign && displayPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).sale_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).sale_price_mv2, isMobileV2)),
                                children: displayPriceFormated
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        container: true,
                        spacing: 2,
                        alignItems: "center",
                        className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).displayPrice_wrapper, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).displayPrice_wrapper_mv2, isMobileV2)),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            style: {
                                padding: "0"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).display_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).display_price_mv2, isMobileV2)),
                                children: [
                                    ((productType === "FLASH_SALE" && isHappeningCampaign || productType === "MEGA_DAY") && percentDealSold < 100 || !isHappeningCampaign && !isCampaignPage) && displayPriceFormated,
                                    (productType === "FLASH_SALE" && isHappeningCampaign || productType === "MEGA_DAY") && percentDealSold === 100 && salePriceFormated
                                ]
                            })
                        })
                    })
                ]
            });
        }
        if (isCampaign && percentDealSold < 100) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    container: true,
                    spacing: 2,
                    alignItems: "center",
                    className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).displayPrice_wrapper, isMobile && (ProductCardInput_styles_module_default()).wrap, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).displayPrice_wrapper_mv2, isMobileV2)),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            style: {
                                padding: "0",
                                width: isMobile && !beta ? "100%" : "auto"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).display_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).display_price_mv2, isMobileV2)),
                                children: [
                                    ((productType === "FLASH_SALE" && isHappeningCampaign || productType === "MEGA_DAY") && percentDealSold < 100 || !isHappeningCampaign && !isCampaignPage) && displayPriceFormated,
                                    (productType === "FLASH_SALE" && isHappeningCampaign || productType === "MEGA_DAY") && percentDealSold === 100 && salePriceFormated,
                                    !isHappeningCampaign && isCampaignPage && (0,StringUtils/* formatPriceMap */.nH)(hidenPrice)
                                ]
                            })
                        }),
                        !isHappeningCampaign && isCampaignPage && displayPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            style: {
                                padding: "0",
                                paddingLeft: "10px",
                                width: isMobile && !beta ? "100%" : "auto"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).sale_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).sale_price_mv2, isMobileV2)),
                                children: displayPriceFormated
                            })
                        }),
                        isHappeningCampaign && salePrice && percentDealSold < 100 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            style: {
                                padding: "0",
                                paddingLeft: "10px",
                                width: isMobile && !beta ? "100%" : "auto"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).sale_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).sale_price_mv2, isMobileV2)),
                                children: salePriceFormated
                            })
                        })
                    ]
                })
            });
        } else if (isDeal && deal) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    container: true,
                    spacing: 1,
                    alignItems: "center",
                    className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).displayPrice_wrapper, isMobile && (ProductCardInput_styles_module_default()).wrap, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).displayPrice_wrapper_mv2, isMobileV2)),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            style: {
                                padding: "0",
                                width: isMobile && !beta ? "100%" : "auto"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).display_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).display_price_mv2, isMobileV2)),
                                children: displayPriceFormated
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            style: {
                                padding: "0",
                                paddingLeft: "10px",
                                width: isMobile && !beta ? "100%" : "auto"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).sale_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).sale_price_mv2, isMobileV2)),
                                children: salePriceFormated
                            })
                        })
                    ]
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: row ? (ProductCardInput_styles_module_default()).price_wrapper : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).price_wrapper, (ProductCardInput_styles_module_default()).price_wrapper_column),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    container: true,
                    alignItems: "stretch",
                    className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).displayPrice_wrapper, isMobile && (ProductCardInput_styles_module_default()).wrap, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).displayPrice_wrapper_mv2, isMobileV2), wishlist && (ProductCardInput_styles_module_default()).pt_55),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            style: {
                                paddingLeft: "0",
                                width: isMobile && !beta ? "100%" : "auto"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).display_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).display_price_mv2, isMobileV2)),
                                children: displayPriceFormated
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                            item: true,
                            children: [
                                errorCode === ErrorCart/* ERROR_CODE_CART.CHANGED_PRICE */.M5.CHANGED_PRICE && currentPrice > displayPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendingDown/* default */.Z, {
                                    className: (ProductCardInput_styles_module_default()).down
                                }),
                                errorCode === ErrorCart/* ERROR_CODE_CART.CHANGED_PRICE */.M5.CHANGED_PRICE && currentPrice < displayPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendingUp/* default */.Z, {
                                    className: (ProductCardInput_styles_module_default()).up
                                })
                            ]
                        })
                    ]
                }),
                isDeal && deal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    style: {
                        width: isMobile && !beta ? "100%" : "auto"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).sale_price, (0,_define_property/* default */.Z)({}, (ProductCardInput_styles_module_default()).sale_price_mv2, isMobileV2)),
                        children: salePriceFormated
                    })
                })
            ]
        });
    };
    var OrderMaximumProduct = function OrderMaximumProduct() {
        var data = [];
        if (isCampaign && isHappeningCampaign && percentDealSold < 100 || isCampaign && productType === "MEGA_DAY" && isHappeningCampaign && percentDealSold < 100) {
            data.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: row ? (ProductCardInput_styles_module_default()).text_desc : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).text_danger_column, (ProductCardInput_styles_module_default()).text_desc)
            }));
        } else if (isHappeningCampaign && percentDealSold === 100 && isCampaignPage) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: (ProductCardInput_styles_module_default()).text_danger,
                children: translateCommon("product_card.missed_promo_price").replace("{displayPrice}", (0,FormatNumber/* formatCurrency */.xG)(campaign === null || campaign === void 0 ? void 0 : campaign.retailPriceValue) || "")
            });
        } else if (isHappeningCampaign && productType === "NORMAL" && percentDealSold === 100 && isCampaignPage) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: (ProductCardInput_styles_module_default()).text_danger,
                children: translateCommon("product_card.missed_promo_price").replace("{displayPrice}", (0,FormatNumber/* formatCurrency */.xG)(displayPrice) || "")
            });
        } else if (messageLimitOrder) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: row ? (ProductCardInput_styles_module_default()).text_desc : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).text_danger_column, (ProductCardInput_styles_module_default()).text_desc),
                children: messageLimitOrder
            });
        }
        if (messageLimitOrder) {
            data.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: row ? (ProductCardInput_styles_module_default()).text_desc : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).text_danger_column, (ProductCardInput_styles_module_default()).text_desc),
                children: messageLimitOrder
            }));
        }
        if (data.length === 0) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (ProductCardInput_styles_module_default()).text_danger,
            children: " "
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: data
        });
    };
    var ref, ref1, ref2;
    var ref3 = (0,esm/* useTranslation */.$G)("common"), translateCommon = ref3.t;
    var ref4 = (0,context/* useCart */.jD)(), updateCartItem = ref4.updateCartItem, removeCartItem = ref4.removeCartItem, mapQuantity = ref4.mapQuantity, validate200Item = ref4.validate200Item;
    var ref5 = (0,context/* useAuth */.aC)(), isAuthenticated = ref5.isAuthenticated, toggleLogin = ref5.toggleLogin;
    var beta = (0,storeMobile/* default */.Z)(function(state) {
        return state.beta;
    });
    var ref6 = (0,context/* useProduct */.iB)(), getInfoProductPerDay = ref6.getInfoProductPerDay, getProductError = ref6.getProductError;
    var isMobileV2 = (0,storeMobile/* default */.Z)(function(state) {
        return state.isMobileV2();
    });
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(), 2), isShowModalRemove = ref7[0], toggleRemove = ref7[1];
    var ref8 = (0,react.useState)(false), isFocus = ref8[0], setIsFocus = ref8[1];
    var ref9 = (0,react.useState)(), inputElement = ref9[0], setInputElement = ref9[1];
    var ref10 = (0,react.useState)(product.quantity || 0), value = ref10[0], setValue = ref10[1];
    var ref11 = campaign || {}, _soldQuantity = ref11.soldQuantity, soldQuantity = _soldQuantity === void 0 ? 0 : _soldQuantity;
    // BV-1586: field giá sau ưu đãi do WebService.convertProductV2 map từ BFF
    var ref12 = product || {}, _isShowPriceAfterDiscount = ref12.isShowPriceAfterDiscount, isShowPriceAfterDiscount = _isShowPriceAfterDiscount === void 0 ? false : _isShowPriceAfterDiscount, _priceAfterDiscountFormated = ref12.priceAfterDiscountFormated, priceAfterDiscountFormated = _priceAfterDiscountFormated === void 0 ? "" : _priceAfterDiscountFormated, _originPriceFormated = ref12.originPriceFormated, originPriceFormated = _originPriceFormated === void 0 ? "" : _originPriceFormated;
    var maxQuantityProduct = isCampaign && availableProducts || isDeal && availableProducts || productMaxQuantity;
    var percentDeal = ((deal === null || deal === void 0 ? void 0 : deal.quantity) || 0) / (deal === null || deal === void 0 ? void 0 : deal.maxQuantity) * 100;
    var outOfStock = (deal === null || deal === void 0 ? void 0 : deal.maxQuantity) === ((deal === null || deal === void 0 ? void 0 : deal.quantity) || 0) || false;
    var timeLeft = (0,utils/* calculateTimeLeft */.VZ)(deal === null || deal === void 0 ? void 0 : deal.startTime) || (0,utils/* calculateTimeLeft */.VZ)(campaign === null || campaign === void 0 ? void 0 : (ref = campaign.campaign) === null || ref === void 0 ? void 0 : ref.startTime) || {};
    var dealReady = Object.keys(timeLeft).length === 0 || false;
    var outOfDate = deal && deal.endTime && new Date(deal.endTime) < new Date() || false;
    var importantList = cartItems === null || cartItems === void 0 ? void 0 : cartItems.filter(function(item) {
        return item.isSelected && item.isImportant;
    });
    var historyBySku = getInfoProductPerDay();
    var ref13 = getProductError({
        product: product
    }), _errorRequiredCertificate = ref13.errorRequiredCertificate, errorRequiredCertificate = _errorRequiredCertificate === void 0 ? false : _errorRequiredCertificate, errorRequiredCertificateMessage = ref13.errorRequiredCertificateMessage;
    (0,react.useEffect)(function() {
        setInputElement(Object.values(searchInput.current)[0]);
    }, []);
    var canDeleteProduct = function() {
        var quantityAfterDel = cartItems.length - 1;
        var importantQuantity = importantList.length;
        var importantQuantityMax = Math.floor(quantityAfterDel * data/* IMPORTANT_PERCENT_MAX */.en);
        if (product.isImportant) importantQuantity -= 1;
        return !(importantQuantity > importantQuantityMax);
    };
    var updateCart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(q) {
            var isReload, response, _tmp, ref, tmp, quantityResponse, _tmp1;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isReload = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : true;
                        if (!q) {
                            return [
                                2
                            ];
                        }
                        _tmp = {};
                        return [
                            4,
                            updateCartItem((_tmp.product = product, _tmp.q = parseFloat(q), _tmp), isReload, cart)
                        ];
                    case 1:
                        response = _state.sent();
                        _tmp1 = {};
                        if ((0,clients/* isValid */.JY)(response)) {
                            ref = (0,clients/* getFirst */.Xi)(response, _tmp1), tmp = ref.quantity, quantityResponse = tmp === void 0 ? null : tmp;
                            if (quantityResponse !== null) {
                                setValue(quantityResponse);
                            }
                        } else {
                            setValue(0);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function updateCart(q) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleRemove = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!cart) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            removeCartItem(product, true)
                        ];
                    case 1:
                        _state.sent();
                        inputElement.value = 0;
                        setValue(0);
                        toggleRemove();
                        return [
                            2
                        ];
                    case 2:
                        if (!canDeleteProduct()) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            removeCartItem(product, cart)
                        ];
                    case 3:
                        _state.sent();
                        inputElement.value = 0;
                        setValue(0);
                        scrollTo(window.pageYOffset);
                        return [
                            2
                        ];
                    case 4:
                        toggleRemove();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleRemove() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancle = function() {
        toggleRemove();
        inputElement.value = value;
        if (value === 0) {
            updateCart(1);
            setValue(1);
        }
    };
    var handleCart = function(val, updateType) {
        if (updateType === "remove") {
            toggleRemove();
        }
        if (updateType === "update") {
            updateCart(val);
        }
    };
    var handleClickInput = function(e) {
        e.stopPropagation();
    };
    var handler = (0,react.useCallback)(function(val, updateType) {
        if (isMobile) {
            (0,debounce/* debounceFunc1000 */.zB)(function() {
                return handleCart(val, updateType);
            });
        } else {
            (0,debounce/* debounceFunc400 */.EI)(function() {
                return handleCart(val, updateType);
            });
        }
    }, []);
    var handleDecrease = function(e) {
        e.stopPropagation();
        if (inputElement.value < 1) return;
        var q = parseInt(inputElement.value, 10) - 1;
        if (q < 1) {
            handler(product, "remove");
            return;
        }
        inputElement.value = q;
        setValue(q);
        handler(q, "update");
    };
    var handleIncrease = function(e) {
        e.stopPropagation();
        if (validate200Item(product === null || product === void 0 ? void 0 : product.sku)) {
            var q = parseInt(inputElement.value, 10) + 1;
            inputElement.value = q;
            setValue(q);
            handler(q, "update");
        }
    };
    var handleInputChange = function(e) {
        try {
            var ref;
            var val = e === null || e === void 0 ? void 0 : (ref = e.currentTarget) === null || ref === void 0 ? void 0 : ref.value.replace(/[^\d]/g, "");
            Object.values(searchInput.current)[0].value = Math.min(maxQuantityProduct, val);
        } catch (error) {
            console.error("Error : ", error);
        }
    };
    var handleOnBlur = function(e) {
        setIsFocus(false);
        if (validate200Item(product === null || product === void 0 ? void 0 : product.sku)) {
            var ref;
            var val = (e === null || e === void 0 ? void 0 : (ref = e.currentTarget) === null || ref === void 0 ? void 0 : ref.value) || value;
            if (/^\d+$/.test(val) && +val >= 0) {
                var curValue = parseFloat(val || 0);
                curValue = Math.min(maxQuantityProduct, curValue);
                if (curValue === value) return;
                // nếu value là 0 thì sẽ remove && quanity trong cartItems
                // TODO: nếu onblur 0 , rồi nhấn vào nút - cho kế bên
                if (curValue === 0 && (mapQuantity === null || mapQuantity === void 0 ? void 0 : mapQuantity.get(product === null || product === void 0 ? void 0 : product.sku)) > 0) {
                    handler(product, "remove");
                    return;
                }
                setValue(curValue);
                if (curValue || curValue !== 0) handler(+curValue, "update");
            }
        } else {
            setValue(0);
            Object.values(searchInput.current)[0].value = 0;
        }
    };
    var handleOnKeyDown = function(e) {
        var positionEl = Number(Object.keys(searchInput.current)[0]);
        var inputs = document === null || document === void 0 ? void 0 : document.querySelectorAll("[class*='product_action'] input");
        if (e.keyCode === 13) {
            var ref;
            handleOnBlur(e);
            (ref = (inputs === null || inputs === void 0 ? void 0 : inputs[positionEl]) || (inputs === null || inputs === void 0 ? void 0 : inputs[positionEl + 1])) === null || ref === void 0 ? void 0 : ref.focus();
        }
        if (e.keyCode === 9) {
            var ref1;
            e.preventDefault();
            inputs === null || inputs === void 0 ? void 0 : (ref1 = inputs[positionEl + 1]) === null || ref1 === void 0 ? void 0 : ref1.focus();
        }
    };
    var checkProductAvailable = function() {
        return status === "OUT_OF_STOCK" || status === "SUSPENDED" || outOfStock || outOfDate;
    };
    if (errorMessageProduct || !product.salePrice || product.status === "STOP_SELLING" || product.salePrice === 0) {
        if (wishlist) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: isMobile ? (ProductCardInput_styles_module_default()).wishlist_err_wrapper_mobile : (ProductCardInput_styles_module_default()).wishlist_err_wrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: row ? (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).text_danger, (ProductCardInput_styles_module_default()).text_center) : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).text_danger_column, (ProductCardInput_styles_module_default()).text_danger),
                        children: errorMessageProduct && translateCommon("product_error.".concat(errorMessageProduct)) || errorMessage || translateCommon("productStatus.STOP_SELLING")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActions/* default */.Z, {
                        className: (0,clsx_m/* default */.Z)(isMobile ? (ProductCardInput_styles_module_default()).btn_del_m_wrapper : (ProductCardInput_styles_module_default()).product_action_column, !isMobile && (ProductCardInput_styles_module_default()).p_0),
                        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (ProductCardInput_styles_module_default()).btn_del_text,
                            onClick: handleDelete,
                            children: translateCommon("btn.delete")
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                            title: translateCommon("cardBuy.remove_wishlist"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                className: (ProductCardInput_styles_module_default()).remove_icon,
                                onClick: handleDelete,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ICON_WISHLIST_DEL_V2 */.G9, {
                                    className: (ProductCardInput_styles_module_default()).icon
                                })
                            })
                        })
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: row ? (ProductCardInput_styles_module_default()).price_wrapper : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).price_wrapper, (ProductCardInput_styles_module_default()).price_wrapper_column)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    className: row ? (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).text_danger, (ProductCardInput_styles_module_default()).text_center, (ProductCardInput_styles_module_default()).text_padding) : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).text_danger_column, (ProductCardInput_styles_module_default()).text_danger),
                    children: errorMessageProduct && translateCommon("product_error.".concat(errorMessageProduct)) || errorMessage || translateCommon("productStatus.STOP_SELLING")
                })
            ]
        });
    }
    // thiếu salePriceLabel thì che trọn giá, tránh để lộ giá thật
    var hidenPrice = (campaign === null || campaign === void 0 ? void 0 : campaign.salePriceLabel) || "???";
    if (isCampaign && (campaign === null || campaign === void 0 ? void 0 : campaign.isValid) === false) {
        var ref14, ref15, ref16;
        var lengthSalePriceLabel = campaign === null || campaign === void 0 ? void 0 : (ref14 = campaign.salePriceLabel) === null || ref14 === void 0 ? void 0 : ref14.length;
        if (lengthSalePriceLabel > 3) hidenPrice = "".concat(campaign === null || campaign === void 0 ? void 0 : (ref15 = campaign.salePriceLabel) === null || ref15 === void 0 ? void 0 : ref15.slice(0, lengthSalePriceLabel - 3)).concat(PRICE_SEPARATOR).concat(campaign === null || campaign === void 0 ? void 0 : (ref16 = campaign.salePriceLabel) === null || ref16 === void 0 ? void 0 : ref16.slice(lengthSalePriceLabel - 3));
    }
    var ContractPrice = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            className: (ProductCardInput_styles_module_default()).contractLabel,
            children: translateCommon("contract_price")
        });
    };
    var checkAndRenderQuantityProduct = function() {
        var text = "";
        historyBySku === null || historyBySku === void 0 ? void 0 : historyBySku.forEach(function(item) {
            if ((item === null || item === void 0 ? void 0 : item.sku) === sku) {
                // text = item?.quantity > 0 && `Bạn đã mua ${formatNumber(item?.quantity)} / ${formatNumber(item?.limitQuantity)} sản phẩm trong ngày`;
                text = (item === null || item === void 0 ? void 0 : item.quantity) > 0 && "".concat(translateCommon("product_card").replace("{quantity}", (0,FormatNumber/* formatNumber */.uf)(item === null || item === void 0 ? void 0 : item.quantity)).replace("{limitQuantity}", (0,FormatNumber/* formatNumber */.uf)(item === null || item === void 0 ? void 0 : item.limitQuantity)));
            }
            if ((item === null || item === void 0 ? void 0 : item.quantity) > (item === null || item === void 0 ? void 0 : item.limitQuantity)) {
                text = "";
            }
        });
        return text;
    };
    var handleOnFocus = function(e) {
        e.preventDefault();
        setIsFocus(true);
    };
    // wishlist page v2
    if (wishlist) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
            className: (0,clsx_m/* default */.Z)(isMobile ? (ProductCardInput_styles_module_default()).card_wishlist_mobile_wrapper : (ProductCardInput_styles_module_default()).card_wishlist_wrapper),
            children: [
                errorRequiredCertificate ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                marginBottom: ""
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        marginBottom: ""
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    style: {
                                        textAlign: "center"
                                    },
                                    className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).text_danger),
                                    children: errorRequiredCertificateMessage
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                            title: translateCommon("cardBuy.remove_wishlist"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                className: (ProductCardInput_styles_module_default()).remove_icon,
                                onClick: handleDelete,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ICON_WISHLIST_DEL_V2 */.G9, {
                                    className: (ProductCardInput_styles_module_default()).icon
                                })
                            })
                        })
                    ]
                }) : noSupportDelivery ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        marginBottom: "16px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                marginBottom: "16px"
                            },
                            className: row ? (ProductCardInput_styles_module_default()).price_wrapper : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).price_wrapper, (ProductCardInput_styles_module_default()).price_wrapper_column),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (ProductCardInput_styles_module_default()).deal_price,
                                children: (0,FormatNumber/* formatCurrency */.xG)(salePrice)
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            style: {
                                textAlign: "center"
                            },
                            className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).text_danger, (ProductCardInput_styles_module_default()).center),
                            children: translateCommon("product_card.not_supporting_province")
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ProductCardInput_styles_module_default()).wishlist_input_container,
                    children: isAuthenticated ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            !isSellerList && errorCode === ErrorCart/* ERROR_CODE_CART.CHANGED_PRICE */.M5.CHANGED_PRICE && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                className: row ? (ProductCardInput_styles_module_default()).text_danger : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).text_change_price, (ProductCardInput_styles_module_default()).text_danger),
                                children: [
                                    translateCommon("cardBuy.product_change_price_Old_price"),
                                    " ",
                                    (0,FormatNumber/* formatCurrency */.xG)(currentPrice)
                                ]
                            }),
                            messageLimitOrder && !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (ProductCardInput_styles_module_default()).text_desc_wishlist,
                                children: messageLimitOrder
                            }),
                            checkAndRenderQuantityProduct() && !isMobile(/*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (ProductCardInput_styles_module_default()).text_quantity_wishlist,
                                children: checkAndRenderQuantityProduct()
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).wishlist_price, isMobile && (ProductCardInput_styles_module_default()).ml_10),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GetPrice, {})
                            }),
                            isDeal && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardActions/* default */.Z, {
                                className: isMobile ? (ProductCardInput_styles_module_default()).product_action_mobile : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).product_action, (ProductCardInput_styles_module_default()).product_action_column),
                                children: [
                                    messageLimitOrder && isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: (ProductCardInput_styles_module_default()).text_desc_wishlist_mobile,
                                        children: messageLimitOrder
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).input_wishlist, isMobile && (ProductCardInput_styles_module_default()).mh_28),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewMinusButton/* default */.Z, {
                                                disabled: !dealReady,
                                                onClick: handleDecrease,
                                                className: isFocus && (ProductCardInput_styles_module_default()).border_focus_left
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewInputProduct/* default */.Z, {
                                                product: product,
                                                id: "".concat(productId),
                                                onChange: handleInputChange,
                                                onBlur: handleOnBlur,
                                                searchInput: function(el) {
                                                    searchInput.current[index] = el; // eslint-disable-line no-param-reassign
                                                },
                                                onClick: handleClickInput,
                                                onKeyDown: handleOnKeyDown,
                                                type: type,
                                                defaultValue: value,
                                                name: name,
                                                className: (0,clsx_m/* default */.Z)(value > 0 && (ProductCardInput_styles_module_default()).has_item, isFocus && (ProductCardInput_styles_module_default()).border_focus_input),
                                                disabled: checkProductAvailable() || !dealReady,
                                                onFocus: handleOnFocus
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewPlusButton/* default */.Z, {
                                                disabled: checkProductAvailable() || !dealReady || maxQuantityProduct && value >= maxQuantityProduct,
                                                onClick: function(e) {
                                                    return handleIncrease(e);
                                                },
                                                className: isFocus && (ProductCardInput_styles_module_default()).border_focus_right
                                            })
                                        ]
                                    }),
                                    checkAndRenderQuantityProduct() && isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: (ProductCardInput_styles_module_default()).text_quantity_wishlist_mobile,
                                        children: checkAndRenderQuantityProduct()
                                    })
                                ]
                            }) || isCampaign && availableProducts > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardActions/* default */.Z, {
                                className: isMobile ? (ProductCardInput_styles_module_default()).product_action_mobile : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).product_action, (ProductCardInput_styles_module_default()).product_action_column),
                                children: [
                                    messageLimitOrder && isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: (ProductCardInput_styles_module_default()).text_desc_wishlist_mobile,
                                        children: messageLimitOrder
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).input_wishlist, isMobile && (ProductCardInput_styles_module_default()).mh_28),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewMinusButton/* default */.Z, {
                                                disabled: !dealReady,
                                                onClick: handleDecrease,
                                                className: isFocus && (ProductCardInput_styles_module_default()).border_focus_left
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewInputProduct/* default */.Z, {
                                                product: product,
                                                id: "".concat(productId),
                                                onChange: handleInputChange,
                                                onClick: handleClickInput,
                                                onBlur: handleOnBlur,
                                                searchInput: function(el) {
                                                    searchInput.current[index] = el; // eslint-disable-line no-param-reassign
                                                },
                                                onKeyDown: handleOnKeyDown,
                                                type: type,
                                                defaultValue: value,
                                                name: name,
                                                className: (0,clsx_m/* default */.Z)(value > 0 && (ProductCardInput_styles_module_default()).has_item, isFocus && (ProductCardInput_styles_module_default()).border_focus_input),
                                                disabled: checkProductAvailable() || !dealReady,
                                                onFocus: handleOnFocus
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewPlusButton/* default */.Z, {
                                                disabled: checkProductAvailable() || !dealReady || availableProducts && value >= availableProducts,
                                                onClick: function() {
                                                    return handleIncrease();
                                                },
                                                className: isFocus && (ProductCardInput_styles_module_default()).border_focus_right
                                            })
                                        ]
                                    }),
                                    checkAndRenderQuantityProduct() && isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: (ProductCardInput_styles_module_default()).text_quantity_wishlist_mobile,
                                        children: checkAndRenderQuantityProduct()
                                    })
                                ]
                            }) || /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardActions/* default */.Z, {
                                className: isMobile ? (ProductCardInput_styles_module_default()).product_action_mobile : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).product_action, (ProductCardInput_styles_module_default()).product_action_column),
                                children: [
                                    messageLimitOrder && isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: (ProductCardInput_styles_module_default()).text_desc_wishlist_mobile,
                                        children: messageLimitOrder
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).input_wishlist, isMobile && (ProductCardInput_styles_module_default()).mh_28),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewMinusButton/* default */.Z, {
                                                disabled: checkProductAvailable(),
                                                onClick: handleDecrease,
                                                className: isFocus && (ProductCardInput_styles_module_default()).border_focus_left
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewInputProduct/* default */.Z, {
                                                product: product,
                                                id: "".concat(productId),
                                                onChange: handleInputChange,
                                                onBlur: handleOnBlur,
                                                onKeyDown: handleOnKeyDown,
                                                searchInput: function(el) {
                                                    searchInput.current[index] = el; // eslint-disable-line no-param-reassign
                                                },
                                                defaultValue: value,
                                                name: name,
                                                className: (0,clsx_m/* default */.Z)(value > 0 && (ProductCardInput_styles_module_default()).has_item, isFocus && (ProductCardInput_styles_module_default()).border_focus_input),
                                                disabled: checkProductAvailable(),
                                                onFocus: handleOnFocus
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewPlusButton/* default */.Z, {
                                                disabled: checkProductAvailable() || maxQuantityProduct && value >= maxQuantityProduct,
                                                onClick: function(e) {
                                                    return handleIncrease(e);
                                                },
                                                className: isFocus && (ProductCardInput_styles_module_default()).border_focus_right
                                            })
                                        ]
                                    }),
                                    checkAndRenderQuantityProduct() && isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: (ProductCardInput_styles_module_default()).text_quantity_wishlist_mobile,
                                        children: checkAndRenderQuantityProduct()
                                    })
                                ]
                            }),
                            isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ProductCardInput_styles_module_default()).btn_del_m_wrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    className: (ProductCardInput_styles_module_default()).btn_del_text,
                                    onClick: handleDelete,
                                    children: translateCommon("btn.delete")
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                                title: translateCommon("cardBuy.remove_wishlist"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                    className: (ProductCardInput_styles_module_default()).remove_icon,
                                    onClick: handleDelete,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ICON_WISHLIST_DEL_V2 */.G9, {
                                        className: (ProductCardInput_styles_module_default()).icon
                                    })
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ProductCardInput_styles_module_default()).view_signin_btn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                            color: "#fff",
                            backgroundColor: "#005C29",
                            className: (ProductCardInput_styles_module_default()).signin_btn,
                            onClick: toggleLogin,
                            children: translateCommon("cardBuy.login_to_see_prices")
                        })
                    })
                }),
                isShowModalRemove && /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoveProductModal/* default */.Z, {
                    product: product,
                    visible: isShowModalRemove,
                    onClose: handleCancle,
                    onRemove: handleRemove
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
        className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).card_wrapper, isMobileV2 && (ProductCardInput_styles_module_default()).card_wrapper_mv2),
        children: [
            !isSellerList && isHalfProgress && (isDeal || isDeal && isHappeningCampaign && percentDealSold === 100) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ProductCardInput_styles_module_default()).deal_wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_DealSectionNew, {
                    dealStartTime: deal === null || deal === void 0 ? void 0 : deal.startTime,
                    dealEndDay: deal === null || deal === void 0 ? void 0 : deal.endTime,
                    dealReady: dealReady,
                    maxQuantity: deal === null || deal === void 0 ? void 0 : deal.maxQuantity,
                    totalSold: (deal === null || deal === void 0 ? void 0 : deal.quantity) || 0,
                    percentDealSold: percentDeal || 0
                })
            }),
            noSupportDelivery ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    marginBottom: "16px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            marginBottom: "16px"
                        },
                        className: row ? (ProductCardInput_styles_module_default()).price_wrapper : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).price_wrapper, (ProductCardInput_styles_module_default()).price_wrapper_column),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (ProductCardInput_styles_module_default()).deal_price,
                            children: (0,FormatNumber/* formatCurrency */.xG)(salePrice)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        style: {
                            textAlign: "center"
                        },
                        className: (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).text_danger, (ProductCardInput_styles_module_default()).center),
                        children: translateCommon("product_card.not_supporting_province")
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: isAuthenticated ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        !isSellerList && errorCode === ErrorCart/* ERROR_CODE_CART.CHANGED_PRICE */.M5.CHANGED_PRICE && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            className: row ? (ProductCardInput_styles_module_default()).text_danger : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).text_change_price, (ProductCardInput_styles_module_default()).text_danger),
                            children: [
                                translateCommon("cardBuy.product_change_price_Old_price"),
                                " ",
                                (0,FormatNumber/* formatCurrency */.xG)(currentPrice)
                            ]
                        }),
                        !isSellerList && (isHappeningCampaign && percentDealSold < 100 || isHappeningCampaign && isDeal && availableProducts > 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ProductCardInput_styles_module_default()).campaign_deal_container,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_DealSectionNew, {
                                dealReady: productType === "NORMAL" ? dealReady : isHappeningCampaign,
                                isHappeningCampaign: isHappeningCampaign,
                                dealStartTime: campaign === null || campaign === void 0 ? void 0 : (ref1 = campaign.campaign) === null || ref1 === void 0 ? void 0 : ref1.startTime,
                                dealEndDay: campaign === null || campaign === void 0 ? void 0 : (ref2 = campaign.campaign) === null || ref2 === void 0 ? void 0 : ref2.endTime,
                                totalSold: soldQuantity || 0,
                                percentDealSold: percentDealSold
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GetPrice, {}),
                        !isSellerList && /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderMaximumProduct, {}),
                        !isSellerList && (isDeal && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActions/* default */.Z, {
                            className: row ? (ProductCardInput_styles_module_default()).product_action : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).product_action, (ProductCardInput_styles_module_default()).product_action_column),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ProductCardInput_styles_module_default()).input_container,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewMinusButton/* default */.Z, {
                                        disabled: !dealReady,
                                        onClick: handleDecrease,
                                        className: isFocus && (ProductCardInput_styles_module_default()).border_focus_left
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewInputProduct/* default */.Z, {
                                        product: product,
                                        id: "key-product-id-".concat(productId),
                                        // không dùng onChange trong ô input nữa, vì đang gõ ( số bị lên xuống thất thường , lưu lại nhiều log trên server)
                                        onChange: handleInputChange,
                                        onBlur: handleOnBlur,
                                        searchInput: function(el) {
                                            searchInput.current[index] = el; // eslint-disable-line no-param-reassign
                                        },
                                        onClick: handleClickInput,
                                        onKeyDown: handleOnKeyDown,
                                        type: type,
                                        defaultValue: value,
                                        name: name,
                                        className: (0,clsx_m/* default */.Z)(value > 0 && (ProductCardInput_styles_module_default()).has_item, isFocus && (ProductCardInput_styles_module_default()).border_focus_input),
                                        disabled: checkProductAvailable() || !dealReady,
                                        onFocus: handleOnFocus
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewPlusButton/* default */.Z, {
                                        disabled: checkProductAvailable() || !dealReady || maxQuantityProduct && value >= maxQuantityProduct,
                                        onClick: function(e) {
                                            return handleIncrease(e);
                                        },
                                        className: isFocus && (ProductCardInput_styles_module_default()).border_focus_right
                                    })
                                ]
                            })
                        }) || isCampaign && availableProducts > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActions/* default */.Z, {
                            className: row ? (ProductCardInput_styles_module_default()).product_action : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).product_action, (ProductCardInput_styles_module_default()).product_action_column),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ProductCardInput_styles_module_default()).input_container,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewMinusButton/* default */.Z, {
                                        disabled: !dealReady,
                                        onClick: handleDecrease,
                                        className: isFocus && (ProductCardInput_styles_module_default()).border_focus_left
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewInputProduct/* default */.Z, {
                                        product: product,
                                        id: "key-product-id-".concat(productId),
                                        // không dùng onChange trong ô input nữa, vì đang gõ ( số bị lên xuống thất thường , lưu lại nhiều log trên server)
                                        onChange: handleInputChange,
                                        onBlur: handleOnBlur,
                                        searchInput: function(el) {
                                            searchInput.current[index] = el; // eslint-disable-line no-param-reassign
                                        },
                                        onClick: handleClickInput,
                                        onKeyDown: handleOnKeyDown,
                                        type: type,
                                        defaultValue: value,
                                        name: name,
                                        className: (0,clsx_m/* default */.Z)(value > 0 && (ProductCardInput_styles_module_default()).has_item, isFocus && (ProductCardInput_styles_module_default()).border_focus_input),
                                        disabled: checkProductAvailable() || !dealReady,
                                        onFocus: handleOnFocus
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewPlusButton/* default */.Z, {
                                        disabled: checkProductAvailable() || !dealReady || availableProducts && value >= availableProducts,
                                        onClick: function(e) {
                                            return handleIncrease(e);
                                        },
                                        className: isFocus && (ProductCardInput_styles_module_default()).border_focus_right
                                    })
                                ]
                            })
                        }) || /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActions/* default */.Z, {
                            className: row ? (ProductCardInput_styles_module_default()).product_action : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).product_action, (ProductCardInput_styles_module_default()).product_action_column),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ProductCardInput_styles_module_default()).input_container,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewMinusButton/* default */.Z, {
                                        disabled: checkProductAvailable(),
                                        onClick: handleDecrease,
                                        className: isFocus && (ProductCardInput_styles_module_default()).border_focus_left
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewInputProduct/* default */.Z, {
                                        product: product,
                                        id: "key-product-id-".concat(productId),
                                        // không dùng onChange trong ô input nữa, vì đang gõ ( số bị lên xuống thất thường , lưu lại nhiều log trên server)
                                        onChange: handleInputChange,
                                        onBlur: handleOnBlur,
                                        onKeyDown: handleOnKeyDown,
                                        onClick: handleClickInput,
                                        searchInput: function(el) {
                                            searchInput.current[index] = el; // eslint-disable-line no-param-reassign
                                        },
                                        defaultValue: value,
                                        name: name,
                                        className: (0,clsx_m/* default */.Z)(value > 0 && (ProductCardInput_styles_module_default()).has_item, isFocus && (ProductCardInput_styles_module_default()).border_focus_input),
                                        disabled: checkProductAvailable(),
                                        onFocus: handleOnFocus
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewPlusButton/* default */.Z, {
                                        disabled: checkProductAvailable() || maxQuantityProduct && value >= maxQuantityProduct,
                                        onClick: function(e) {
                                            return handleIncrease(e);
                                        },
                                        className: isFocus && (ProductCardInput_styles_module_default()).border_focus_right
                                    })
                                ]
                            })
                        })),
                        !isSellerList && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: row ? (ProductCardInput_styles_module_default()).text_desc : (0,clsx_m/* default */.Z)((ProductCardInput_styles_module_default()).text_danger_column, (ProductCardInput_styles_module_default()).text_desc),
                            children: checkAndRenderQuantityProduct()
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ProductCardInput_styles_module_default()).view_signin_btn,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                        color: "#fff",
                        backgroundColor: "#005C29",
                        className: (ProductCardInput_styles_module_default()).signin_btn,
                        onClick: toggleLogin,
                        children: translateCommon("cardBuy.login_to_see_prices")
                    })
                })
            }),
            isShowModalRemove && /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoveProductModal/* default */.Z, {
                product: product,
                visible: isShowModalRemove,
                onClose: handleCancle,
                onRemove: handleRemove
            })
        ]
    });
};
/* harmony default export */ var mocules_ProductCardInput = (ProductCardInput);


/***/ }),

/***/ 22535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mocules_TagComponent; },
  "T": function() { return /* binding */ getShowTags; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(868);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js
var withStyles = __webpack_require__(52543);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/deviceUtils.js
var deviceUtils = __webpack_require__(97121);
;// CONCATENATED MODULE: ./src/components-v2/mocules/TooltipMobile/index.js







var CustomizeTooltip = (0,withStyles/* default */.Z)({
    tooltip: {
        backgroundColor: "#ffffff",
        boxShadow: " 0px 0px 6px rgba(0, 0, 0, 0.05)",
        borderRadius: "5px",
        width: "auto",
        maxWidth: "249px",
        border: "1px solid #e9e9e9",
        padding: "10px",
        color: "black"
    }
})(Tooltip/* default */.ZP);
function TooltipMobile(param) {
    var _valueTitle = param.valueTitle, valueTitle = _valueTitle === void 0 ? "" : _valueTitle, children = param.children, isMobile = param.isMobile, classNameChildren = param.classNameChildren, classNameTooltip = param.classNameTooltip;
    var isTablet = deviceUtils/* default.isTablet */.Z.isTablet();
    var isDeviceMobile = isTablet || isMobile;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isHoverTooltip = ref[0], setIsHoverTooltip = ref[1];
    if (!children || !isDeviceMobile || !valueTitle) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomizeTooltip, {
        enterTouchDelay: 0,
        title: valueTitle,
        open: isHoverTooltip,
        placement: "top",
        className: (0,clsx_m/* default */.Z)(classNameTooltip),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            onClick: function() {
                return setIsHoverTooltip(true);
            },
            onMouseOver: function() {
                return setIsHoverTooltip(true);
            },
            onMouseLeave: function() {
                return setIsHoverTooltip(false);
            },
            onFocus: function() {
                return setIsHoverTooltip(true);
            },
            role: "presentation",
            className: (0,clsx_m/* default */.Z)(classNameChildren),
            children: children
        })
    });
}
/* harmony default export */ var mocules_TooltipMobile = (TooltipMobile);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 12 modules
var Box = __webpack_require__(80343);
// EXTERNAL MODULE: ./src/components/mocules/TagType/index.js + 1 modules
var TagType = __webpack_require__(85201);
// EXTERNAL MODULE: ./src/zustand-lib/storeMobile.js
var storeMobile = __webpack_require__(35810);
// EXTERNAL MODULE: ./src/components/atoms/AdditionalTooltip/styles.module.css
var styles_module = __webpack_require__(84446);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/atoms/AdditionalTooltip/index.js










var AdditionalTooltip = function(param) {
    var tags = param.tags, _exp = param.exp, exp = _exp === void 0 ? null : _exp;
    var CustomizeTooltip = (0,withStyles/* default */.Z)({
        tooltip: {
            backgroundColor: "#ffffff",
            border: "1px solid #eaeaea",
            display: "flex",
            justifyContent: "space-beetwen",
            flexWrap: "wrap"
        },
        arrow: {
            "&:before": {
                border: "1px solid #eaeaea",
                backgroundColor: "#ffffff"
            }
        }
    })(Tooltip/* default */.ZP);
    var isMobileV2 = (0,storeMobile/* default */.Z)(function(state) {
        return state.isMobileV2();
    });
    var remainTagType = tags === null || tags === void 0 ? void 0 : tags.map(function(tag) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            style: {
                padding: "2px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagType/* default */.ZP, {
                item: tag,
                exp: exp
            })
        }, tag);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomizeTooltip, {
        title: remainTagType,
        disableFocusListener: true,
        disableTouchListener: true,
        className: (0,clsx_m/* default */.Z)((styles_module_default()).tag_quantity),
        arrow: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            className: (0,clsx_m/* default */.Z)((styles_module_default()).tag, (0,_define_property/* default */.Z)({}, (styles_module_default()).tag_mv2, isMobileV2)),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                style: {
                    marginBottom: "8px"
                },
                children: "..."
            })
        })
    });
};
/* harmony default export */ var atoms_AdditionalTooltip = (AdditionalTooltip);

// EXTERNAL MODULE: ./src/constants/TagTypeProps/index.js
var TagTypeProps = __webpack_require__(11917);
// EXTERNAL MODULE: ./src/constants/Tags/index.js
var Tags = __webpack_require__(91983);
// EXTERNAL MODULE: ./src/sysconfig/index.js
var sysconfig = __webpack_require__(66225);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js
var v4 = __webpack_require__(72045);
// EXTERNAL MODULE: ./src/zustand-lib/storeGlobal.js + 1 modules
var storeGlobal = __webpack_require__(39423);
// EXTERNAL MODULE: ./src/components/mocules/TagComponent/style.module.css
var style_module = __webpack_require__(66086);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./src/components/mocules/TagComponent/index.js
/*
 * @deprecated Module tag cũ (port từ VN). Bản chuẩn cho TH là
 * `src/components-v2/organisms/pages/landingPageThai/mocules/TagComponent` + `src/utils/TagUtils.js`.
 *
 * Còn sống vì đang phục vụ giỏ hàng / checkout / đơn hàng / bulk-order / quick-order / export XLSX,
 * và vì chip ở đây có hình dạng khác bản TH (viền + nền nhạt, có nút "..." gom tag dư, có ngày
 * cận date) nên hợp nhất là thay đổi design, cần sign-off — xem docs/product-tag-display-spec.md.
 *
 * Đừng thêm rule mới vào đây.
 */ // xử lý tag
















/*
TAG
Rule 1: 3 Tag Priority bắt buộc phải hiển thị đủ: Thứ tự ưu tiên hiển thị: Cận date (text) - Hóa đơn nhanh (có icon) - Đặt trước 7 ngày (text) (các tags còn lại có thể nằm trong nút …)
Rule 2: Sp chứa Tag text (>1) và tag icon (>1) sẽ hiển thị:
Th1: nếu có tag priority → ưu tiển hiển thị theo Rule 1
TH2: nếu không có tag priority → hiển thị 1 tag text và 2 tag icon (đảm bảo là nằm trên cùng 1 dòng)
Rule 3: nếu ko có tags icon nào hiển thị thì sẽ hiển thị tags có chữ ra ngoài, max là 2 tags text (cho phép rớt xuống thành 2 dòng ở trường hợp này)
Giao diện chỗ +number đổi thành nút ba chấm … (đang chờ update UI để update vô card, dev cứ giữ … như bản web hiện tại là dc) (rule của nút vẫn giữ như trong card)
  */ var TooltipTagMobile = function(param) {
    var remainTags = param.remainTags, isMobile = param.isMobile, _isChatMobile = param.isChatMobile, isChatMobile = _isChatMobile === void 0 ? false : _isChatMobile;
    var isMobileV2 = (0,storeMobile/* default */.Z)(function(state) {
        return state.isMobileV2();
    });
    var tagType = remainTags === null || remainTags === void 0 ? void 0 : remainTags.map(function(tag) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
            style: {
                padding: "2px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagType/* default */.ZP, {
                item: tag
            })
        }, "tag-".concat(tag));
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_TooltipMobile, {
        valueTitle: tagType,
        classNameChildren: (0,clsx_m/* default */.Z)((style_module_default()).tag_quantity, (0,_define_property/* default */.Z)({}, (style_module_default()).tag_quantity_mv2, isMobileV2)),
        classNameTooltip: (style_module_default()).tagMobile,
        isMobile: isMobile,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
            className: (0,clsx_m/* default */.Z)(isChatMobile && (style_module_default()).chatMobile_moreTag),
            onClick: function(e) {
                return e.stopPropagation();
            },
            style: {
                marginBottom: "8px"
            },
            children: "..."
        })
    });
};
var tagsHidden = [
    sysconfig/* TAG_NEW */.cC
];
var TAG_PRIORITY = [
    "NEAR_EXPIRATION",
    "HOADONNHANH",
    "HANG_DAT_TRUOC"
];
var tagHideHoaDonNhanh = [
    Tags/* ENUM_TAG_CODES.HANG_DIEM */.c.HANG_DIEM,
    Tags/* ENUM_TAG_CODES.HANG_HANG */.c.HANG_HANG
];
var getShowTags = function(tags, getStyleBySlugOfTag, provinceCode) {
    // Cận date- Hóa đơn nhanh - Đặt trước 7 ngày - Có ở kho - Bán Chạy - Giá Tốt - Nhãn hàng 3 tốt
    var sortprioritizedTag = tags === null || tags === void 0 ? void 0 : tags.filter(function(tag) {
        return (TagTypeProps/* default */.Z[tag] || getStyleBySlugOfTag && getStyleBySlugOfTag(tag)) && tagsHidden.indexOf(tag) === -1;
    }).sort(function(a, b) {
        var ref, ref1;
        return (((ref = TagTypeProps/* default */.Z[b]) === null || ref === void 0 ? void 0 : ref.index) || 10) - (((ref1 = TagTypeProps/* default */.Z[a]) === null || ref1 === void 0 ? void 0 : ref1.index) || 10);
    });
    // bỏ duplicate
    var setTags = Array.from(new Set(sortprioritizedTag));
    // 05Augh2022
    /*
    nếu SP có tag hàng hãng / hàng điểm thì auto ẩn Tag hoá đơn nhanh 
    ẩn trên toàn bộ trang
    khi ẩn tag hoá đơn nhanh thì sẽ ưu tiên  Hàng hãng -> Hàng Điểm 
    https://buymed.atlassian.net/browse/APO-772 
  */ var indexTagHoaDonNhanh = setTags.indexOf(Tags/* ENUM_TAG_CODES.HOADONNHANH */.c.HOADONNHANH);
    if (indexTagHoaDonNhanh >= 0 && setTags.some(function(tag) {
        return tagHideHoaDonNhanh.includes(tag);
    })) {
        setTags.splice(indexTagHoaDonNhanh, 1);
    }
    // check user miền bắc chỉ hiển thị tag HANG_DAT_TRUOC
    var isUserInRegionMb = sysconfig/* REGION_MB.indexOf */.nt.indexOf("".concat(provinceCode)) < 0;
    var indexTagHangDatTruoc = setTags.indexOf(sysconfig/* TAG_HANG_DAT_TRUOC */.lE);
    if (indexTagHangDatTruoc >= 0 && isUserInRegionMb) {
        setTags.splice(indexTagHangDatTruoc, 1);
    }
    return setTags;
};
var TagComponent = function(param) {
    var product = param.product, _isProductCard = param.isProductCard, isProductCard = _isProductCard === void 0 ? true : _isProductCard, _isSellerList = param.isSellerList, isSellerList = _isSellerList === void 0 ? false : _isSellerList, _isCombo = param.isCombo, isCombo = _isCombo === void 0 ? false : _isCombo, _isGift = param.isGift, isGift = _isGift === void 0 ? false : _isGift, _isMobileV2 = param.isMobileV2, isMobileV2 = _isMobileV2 === void 0 ? false : _isMobileV2, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, _isShowDeal = param.isShowDeal, isShowDeal = _isShowDeal === void 0 ? true : _isShowDeal, link = param.link, isLinkTagDeal = param.isLinkTagDeal, _isChatMobile = param.isChatMobile, isChatMobile = _isChatMobile === void 0 ? false : _isChatMobile;
    // const { getStyleBySlugOfTag } = useSetting();
    var getStyleBySlugOfTag = (0,storeGlobal/* useStore */.o)(function(state) {
        return state === null || state === void 0 ? void 0 : state.getStyleBySlugOfTag;
    }) || null;
    var user = (0,storeGlobal/* useStore */.o)(function(state) {
        return state === null || state === void 0 ? void 0 : state.user;
    }) || null;
    var beta = (0,storeMobile/* default */.Z)(function(state) {
        return state.beta;
    });
    // nếu gift thì không hiển thị tag
    if (isSellerList || isGift) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    var ref = product || {}, _tags = ref.tags, tags = _tags === void 0 ? [] : _tags, _statusData = ref.statusData, statusData = _statusData === void 0 ? {} : _statusData, _expiredDate = ref.expiredDate, expiredDate = _expiredDate === void 0 ? "" : _expiredDate;
    // nếu combo chỉ hiển thị tag hoá đơn nhanh
    if (isCombo) {
        return tags === null || tags === void 0 ? void 0 : tags.filter(function(tag) {
            return tag === Tags/* ENUM_TAG_CODES.HOADONNHANH */.c.HOADONNHANH || tag === sysconfig/* TAG_HANG_DAT_TRUOC */.lE;
        }).map(function(item) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(TagType/* default */.ZP, {
                item: item,
                exp: statusData === null || statusData === void 0 ? void 0 : statusData.date,
                isTooltip: isProductCard && TagType/* tagTypePropsArr.indexOf */.fb.indexOf(item),
                link: link,
                isLinkTagDeal: isLinkTagDeal
            }, (0,v4/* default */.Z)());
        });
    }
    // Cận date- Hóa đơn nhanh - Đặt trước 7 ngày - Có ở kho - Bán Chạy - Giá Tốt - Nhãn hàng 3 tốt
    var sortprioritizedTag = tags === null || tags === void 0 ? void 0 : tags.filter(function(tag) {
        return (TagTypeProps/* default */.Z[tag] || getStyleBySlugOfTag && getStyleBySlugOfTag(tag)) && tagsHidden.indexOf(tag) === -1;
    }).sort(function(a, b) {
        var ref, ref1;
        return (((ref = TagTypeProps/* default */.Z[b]) === null || ref === void 0 ? void 0 : ref.index) || 10) - (((ref1 = TagTypeProps/* default */.Z[a]) === null || ref1 === void 0 ? void 0 : ref1.index) || 10);
    });
    // bỏ duplicate
    var setTags = Array.from(new Set(sortprioritizedTag));
    // 05Augh2022
    /*
    nếu SP có tag hàng hãng / hàng điểm thì auto ẩn Tag hoá đơn nhanh 
    ẩn trên toàn bộ trang
    khi ẩn tag hoá đơn nhanh thì sẽ ưu tiên  Hàng hãng -> Hàng Điểm 
    https://buymed.atlassian.net/browse/APO-772 
  */ var indexTagHoaDonNhanh = setTags.indexOf(Tags/* ENUM_TAG_CODES.HOADONNHANH */.c.HOADONNHANH);
    if (indexTagHoaDonNhanh >= 0 && setTags.some(function(tag) {
        return tagHideHoaDonNhanh.includes(tag);
    })) {
        setTags.splice(indexTagHoaDonNhanh, 1);
    }
    // check user miền bắc chỉ hiển thị tag HANG_DAT_TRUOC
    var isUserInRegionMb = sysconfig/* REGION_MB.indexOf */.nt.indexOf("".concat(user === null || user === void 0 ? void 0 : user.provinceCode)) < 0;
    var indexTagHangDatTruoc = setTags.indexOf(sysconfig/* TAG_HANG_DAT_TRUOC */.lE);
    if (indexTagHangDatTruoc >= 0 && isUserInRegionMb) {
        setTags.splice(indexTagHangDatTruoc, 1);
    }
    // Ở trang giỏ hàng thì  không hiển thị tag DEAL
    if (!isShowDeal) {
        var indexDeal = setTags.indexOf("DEAL");
        if (indexDeal >= 0) {
            setTags.splice(indexDeal, 1);
        }
    }
    // isMobile show hết
    // if (isMobile) {
    //   return setTags.map((item) => <TagType key={uuidv4()} item={item} exp={statusData?.date} />);
    // }
    // thêm rule 28Jun2022
    // nếu có 3 tag thì hiển thị hết
    // isProductCard  = true -> hiển thị icon , và rule ở trên
    if (isProductCard && (setTags === null || setTags === void 0 ? void 0 : setTags.length) > 3) {
        // check có tag priority không
        // rule 1
        var tagPriorityCur = setTags.filter(function(t) {
            return TAG_PRIORITY.indexOf(t) >= 0;
        });
        // rule 2 : nếu không có tagPriority -> 1 tag tex & 1 tag icon
        if ((tagPriorityCur === null || tagPriorityCur === void 0 ? void 0 : tagPriorityCur.length) === 0) {
            var tagIcons = [];
            var tagNoIcons = [];
            var tagStyles = setTags.map(function(tag) {
                return TagTypeProps/* default */.Z[tag] || getStyleBySlugOfTag && getStyleBySlugOfTag(tag);
            });
            tagStyles.forEach(function(tag) {
                if (tag) {
                    if (tag.isTooltip) {
                        tagIcons.push(tag === null || tag === void 0 ? void 0 : tag.code);
                    } else {
                        tagNoIcons.push(tag === null || tag === void 0 ? void 0 : tag.code);
                    }
                }
            });
            // nếu có 2 tag icon -> 1 icon 1 text
            if ((tagIcons === null || tagIcons === void 0 ? void 0 : tagIcons.length) >= 1 && (tagNoIcons === null || tagNoIcons === void 0 ? void 0 : tagNoIcons.length) > 0) {
                tagPriorityCur = (0,_to_consumable_array/* default */.Z)(tagIcons.splice(0, 2)).concat([
                    tagNoIcons === null || tagNoIcons === void 0 ? void 0 : tagNoIcons[0]
                ]);
            } else {
                // nếu không có 2 tag Icon thì sẽ hiển thị 2 tag text
                tagPriorityCur = tagNoIcons.splice(0, 2);
            }
        }
        var remainTags = setTags.filter(function(tag) {
            return tagPriorityCur.indexOf(tag) === -1;
        });
        if ((tagPriorityCur === null || tagPriorityCur === void 0 ? void 0 : tagPriorityCur.length) <= 2) {
            tagPriorityCur = tagPriorityCur.concat(remainTags.splice(0, 3 - tagPriorityCur.length));
        }
        // const remainTagType = remainTags?.map((tag) => (
        //   <Box style={{ padding: '2px' }}>
        //     <TagType item={tag} />
        //   </Box>
        // ));
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                (tagPriorityCur === null || tagPriorityCur === void 0 ? void 0 : tagPriorityCur.length) > 0 && tagPriorityCur.map(function(item) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(TagType/* default */.ZP, {
                        item: item,
                        exp: item === "NEAR_EXPIRATION" ? expiredDate : statusData === null || statusData === void 0 ? void 0 : statusData.date,
                        isTooltip: isProductCard && TagType/* tagTypePropsArr.indexOf */.fb.indexOf(item),
                        isLinkTagDeal: isLinkTagDeal,
                        link: link
                    }, (0,v4/* default */.Z)());
                }),
                (remainTags === null || remainTags === void 0 ? void 0 : remainTags.length) > 0 && (isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipTagMobile, {
                    remainTags: remainTags,
                    isMobile: beta ? isMobileV2 : isMobile,
                    isChatMobile: isChatMobile
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_AdditionalTooltip, {
                    tags: remainTags
                }))
            ]
        });
    }
    // isProductCard  = false -> trang chi tiết - hiển thị full,
    return setTags.map(function(item) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(TagType/* default */.ZP, {
            item: item,
            exp: item !== "NEAR_EXPIRATION" ? statusData === null || statusData === void 0 ? void 0 : statusData.date : expiredDate,
            isTooltip: isProductCard && TagType/* tagTypePropsArr.indexOf */.fb.indexOf(item),
            isLinkTagDeal: isLinkTagDeal,
            link: link
        }, (0,v4/* default */.Z)());
    });
};
/* harmony default export */ var mocules_TagComponent = (TagComponent);


/***/ }),

/***/ 85201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ mocules_TagType; },
  "f9": function() { return /* binding */ getTagName; },
  "fb": function() { return /* binding */ tagTypePropsArr; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/constants/TagTypeProps/index.js
var TagTypeProps = __webpack_require__(11917);
// EXTERNAL MODULE: ./src/context/index.js + 10 modules
var context = __webpack_require__(33436);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 6 modules
var esm = __webpack_require__(5233);
// EXTERNAL MODULE: ./src/sysconfig/index.js
var sysconfig = __webpack_require__(66225);
// EXTERNAL MODULE: ./src/utils/index.js + 5 modules
var utils = __webpack_require__(76480);
// EXTERNAL MODULE: ./src/zustand-lib/storeGlobal.js + 1 modules
var storeGlobal = __webpack_require__(39423);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@fortawesome/fontawesome-svg-core/index.es.js
var index_es = __webpack_require__(78947);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-brands-svg-icons/index.es.js
var free_brands_svg_icons_index_es = __webpack_require__(51417);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.es.js
var free_solid_svg_icons_index_es = __webpack_require__(51436);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var react_fontawesome_index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(868);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/components/atoms/index.js + 15 modules
var atoms = __webpack_require__(53316);
// EXTERNAL MODULE: ./src/constants/Paths/index.js
var Paths = __webpack_require__(199);
// EXTERNAL MODULE: ./src/zustand-lib/storeMobile.js
var storeMobile = __webpack_require__(35810);
// EXTERNAL MODULE: ./src/components/mocules/ProductTag/tag.module.css
var tag_module = __webpack_require__(12404);
var tag_module_default = /*#__PURE__*/__webpack_require__.n(tag_module);
;// CONCATENATED MODULE: ./src/components/mocules/ProductTag/index.js
/* eslint-disable no-param-reassign */ /*
 * @deprecated Module tag cũ (port từ VN). Bản chuẩn cho TH là
 * `src/components-v2/organisms/pages/landingPageThai/mocules/TagComponent` + `src/utils/TagUtils.js`.
 *
 * Còn sống vì đang phục vụ giỏ hàng / checkout / đơn hàng / bulk-order / quick-order / export XLSX,
 * và vì chip ở đây có hình dạng khác bản TH (viền + nền nhạt, có nút "..." gom tag dư, có ngày
 * cận date) nên hợp nhất là thay đổi design, cần sign-off — xem docs/product-tag-display-spec.md.
 *
 * Đừng thêm rule mới vào đây.
 */ 
















var iconList = [
    {
        label: "✯ Ng\xf4i sao",
        value: "star",
        icon: free_solid_svg_icons_index_es.faStar
    },
    {
        label: "＋ Cộng",
        value: "plus",
        icon: free_solid_svg_icons_index_es.faPlus
    },
    {
        label: "♫ Nốt nhạc",
        value: "music",
        icon: free_solid_svg_icons_index_es.faMusic
    },
    {
        label: "❄ Tuyết",
        value: "snowflake",
        icon: free_solid_svg_icons_index_es.faSnowflake
    },
    {
        label: "✈ M\xe1y bay",
        value: "plane",
        icon: free_solid_svg_icons_index_es.faPlane
    },
    {
        label: "❤ Tr\xe1i tim",
        value: "heart",
        icon: free_solid_svg_icons_index_es.faHeart
    },
    {
        label: "ϟ S\xe9t",
        value: "bolt",
        icon: free_solid_svg_icons_index_es.faBolt
    },
    {
        label: "☀ Mặt trời",
        value: "sun",
        icon: free_solid_svg_icons_index_es.faSun
    },
    {
        label: "☁ M\xe2y",
        value: "cloud",
        icon: free_solid_svg_icons_index_es.faCloud
    },
    {
        label: "♨ Lửa",
        value: "fab gripfire",
        icon: free_brands_svg_icons_index_es.faGripfire
    },
    {
        label: "Qu\xe0 tặng",
        value: "gift",
        icon: free_solid_svg_icons_index_es.faGift
    },
    {
        label: "Giao nhanh",
        value: "shipping-fast",
        icon: free_solid_svg_icons_index_es.faShippingFast
    },
    {
        label: "H\xf3a đơn",
        value: "file-invoice-dollar",
        icon: free_solid_svg_icons_index_es.faFileInvoiceDollar
    },
    {
        label: "B\xe1nh sinh nhật",
        value: "birthday-cake",
        icon: free_solid_svg_icons_index_es.faBirthdayCake
    },
    {
        label: "Huy chương",
        value: "medal",
        icon: free_solid_svg_icons_index_es.faMedal
    },
    {
        label: "Th\xedch",
        value: "thumbs-up",
        icon: free_solid_svg_icons_index_es.faThumbsUp
    },
    {
        label: "Trẻ em",
        value: "baby",
        icon: free_solid_svg_icons_index_es.faBaby
    },
    {
        label: "Giọt nước",
        value: "tint",
        icon: free_solid_svg_icons_index_es.faTint
    },
    {
        label: "B\xf9ng nổ",
        value: "bahai",
        icon: free_solid_svg_icons_index_es.faBahai
    }, 
];
iconList.forEach(function(icon) {
    index_es.library.add(icon.icon);
});
index_es.dom.watch();
var getUrlTag = function(param) {
    var slug = param.slug, url = param.url, code = param.code;
    if (url) return url;
    if (slug) return "/tag/".concat(slug);
    return "".concat(Paths/* PRODUCTS_LOADING_URL */.iB, "?tag=").concat(code);
};
function ProductTag(param) {
    var name = param.name, preIcon = param.preIcon, _Icon = param.Icon, Icon = _Icon === void 0 ? null : _Icon, nameAsTooltip = param.nameAsTooltip, textColor = param.textColor, style = param.style, styleName = param.styleName, code = param.code, backgroundColor = param.backgroundColor, date = param.date, _isTooltip = param.isTooltip, isTooltip = _isTooltip === void 0 ? false : _isTooltip, _url = param.url, url = _url === void 0 ? null : _url, borderColor = param.borderColor, _isStyleV2 = param.isStyleV2, isStyleV2 = _isStyleV2 === void 0 ? false : _isStyleV2, slug = param.slug, link = param.link, isLinkTagDeal = param.isLinkTagDeal, tcode = param.tcode;
    var ref, ref1;
    var isMobileV2 = (0,storeMobile/* default */.Z)(function(state) {
        return state.isMobileV2();
    });
    var ref2 = (0,esm/* useTranslation */.$G)("common"), translateCommon = ref2.t;
    // // set cho mobile version 2
    // if (!isDesktop && beta) {
    //   return (
    //     <MobileProductTag
    //       style={{
    //         borderColor: borderColor || backgroundColor,
    //         color: textColor,
    //         backgroundColor,
    //         ...(style || {}),
    //       }}
    //       name={name}
    //       Icon={Icon}
    //       preIcon={preIcon}
    //     />
    //   );
    // }
    // parse preIcon
    if (preIcon) {
        if (typeof preIcon === "string") {
            if (preIcon.indexOf(" ") > 0) {
                preIcon = preIcon.split(" ");
            }
        } else if (typeof preIcon === "object" && preIcon.value) {
            preIcon = preIcon.value;
        }
    }
    // capitalize
    name = (ref1 = (ref = name === null || name === void 0 ? void 0 : name.split(" ")) === null || ref === void 0 ? void 0 : ref.map(function(word) {
        return word.length > 1 ? word.charAt(0).toUpperCase() + word.substr(1) : word.toUpperCase();
    })) === null || ref1 === void 0 ? void 0 : ref1.join(" ");
    if (isTooltip && (Icon || preIcon)) {
        var urlTag = getUrlTag({
            code: code,
            url: code === "DEAL" && isLinkTagDeal ? link : url,
            slug: slug
        });
        var _obj;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* LinkComp */.vk, {
            stopProp: true,
            removeStyles: true,
            href: urlTag,
            "data-test": "tags-".concat(code),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                title: tcode ? translateCommon("tag.".concat(code)) : name,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    style: (0,_object_spread/* default */.Z)({
                        borderColor: borderColor || backgroundColor,
                        color: textColor,
                        backgroundColor: backgroundColor
                    }, style || {}),
                    // className={isStyleV2 ? styles.tag_containerv2 : styles.icon_tag_container}
                    className: (0,clsx_m/* default */.Z)((_obj = {}, (0,_define_property/* default */.Z)(_obj, (tag_module_default()).icon_tag_container, !isStyleV2), (0,_define_property/* default */.Z)(_obj, (tag_module_default()).tag_containerv2, isStyleV2), (0,_define_property/* default */.Z)(_obj, (tag_module_default()).tag_container_mobilev2, isMobileV2), _obj)),
                    onClick: function() {
                        utils/* gtag.clickTagInProduct */.SX.clickTagInProduct(name);
                    },
                    children: [
                        Icon && Icon,
                        preIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_fontawesome_index_es.FontAwesomeIcon, {
                            icon: preIcon
                        })
                    ]
                })
            })
        });
    }
    // normal display
    if (!nameAsTooltip && name) {
        var urlTag1 = getUrlTag({
            tcode: tcode,
            code: code,
            url: code === "DEAL" && isLinkTagDeal ? link : url,
            slug: slug
        });
        var _obj1, _obj2;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* LinkComp */.vk, {
            stopProp: true,
            removeStyles: true,
            href: urlTag1,
            "data-test": "tags-".concat(code),
            prefetch: false,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                style: (0,_object_spread/* default */.Z)({
                    borderColor: borderColor || backgroundColor,
                    color: textColor,
                    backgroundColor: backgroundColor
                }, style || {}),
                // className={clsx(isStyleV2 ? styles.tag_containerv2 : styles.tag_container, date ? styles.date_tag_container : styles.normal_tag_container)}
                className: (0,clsx_m/* default */.Z)((_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, (tag_module_default()).tag_container, !isStyleV2), (0,_define_property/* default */.Z)(_obj1, (tag_module_default()).tag_containerv2, isStyleV2), (0,_define_property/* default */.Z)(_obj1, (tag_module_default()).normal_tag_container, !date), (0,_define_property/* default */.Z)(_obj1, (tag_module_default()).date_tag_container, date), (0,_define_property/* default */.Z)(_obj1, (tag_module_default()).tag_container_mobilev2, isMobileV2), _obj1)),
                onClick: function() {
                    utils/* gtag.clickTagInProduct */.SX.clickTagInProduct(name);
                },
                children: [
                    Icon && Icon,
                    preIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_fontawesome_index_es.FontAwesomeIcon, {
                        icon: preIcon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: (0,clsx_m/* default */.Z)((_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, (tag_module_default()).nameTag, true), (0,_define_property/* default */.Z)(_obj2, (tag_module_default()).nameTagMobileV2, isMobileV2), _obj2)),
                        style: (0,_object_spread/* default */.Z)({}, styleName || {}),
                        children: tcode ? translateCommon("tag.".concat(code)) : name
                    })
                ]
            })
        });
    }
    // quick order display
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: preIcon && name && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
            title: tcode ? translateCommon("tag.".concat(code)) : name,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: (0,_object_spread/* default */.Z)({
                    borderColor: borderColor || backgroundColor,
                    color: textColor,
                    backgroundColor: backgroundColor
                }, style || {}),
                className: isStyleV2 ? (tag_module_default()).tag_containerv2 : (tag_module_default()).tag_container,
                data: "no link",
                children: [
                    Icon && Icon,
                    preIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_fontawesome_index_es.FontAwesomeIcon, {
                        icon: preIcon
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/mocules/TagType/index.js
/*
 * @deprecated Module tag cũ (port từ VN). Bản chuẩn cho TH là
 * `src/components-v2/organisms/pages/landingPageThai/mocules/TagComponent` + `src/utils/TagUtils.js`.
 *
 * Còn sống vì đang phục vụ giỏ hàng / checkout / đơn hàng / bulk-order / quick-order / export XLSX,
 * và vì chip ở đây có hình dạng khác bản TH (viền + nền nhạt, có nút "..." gom tag dư, có ngày
 * cận date) nên hợp nhất là thay đổi design, cần sign-off — xem docs/product-tag-display-spec.md.
 *
 * Đừng thêm rule mới vào đây.
 */ 









var tagTypePropsArr = [
    "OUT_OF_STOCK",
    "SUSPENDED",
    "GIFT",
    "FLASH_SALE",
    "MEGA_DAY",
    "DEAL",
    sysconfig/* TAG_HANG_DAT_TRUOC */.lE,
    "FV2U",
    "2ABC",
    "HOADONNHANH",
    "BAN_CHAY",
    "BANCHAY",
    "Y7GB",
    "84AB",
    "3ABC", 
];
var tagIconArr = [
    "GIAONHANH",
    "W80T",
    "BAN_CHAY",
    "BANCHAY",
    "HOADONNHANH"
];
var tagNoDisplayArr = [
    sysconfig/* TAG_NEW */.cC
];
var getTagName = function(item, getStyleBySlugOfTag) {
    var ref;
    if (item === "NEAR_EXPIRATION") {
        return "Cận date";
    }
    if ((tagNoDisplayArr === null || tagNoDisplayArr === void 0 ? void 0 : tagNoDisplayArr.indexOf(item)) >= 0) {
        return null;
    }
    var tagInfo = TagTypeProps/* default */.Z[item];
    if (tagInfo === null || tagInfo === void 0 ? void 0 : tagInfo.name) {
        return tagInfo.name;
    }
    return ((ref = getStyleBySlugOfTag(item)) === null || ref === void 0 ? void 0 : ref.name) || "";
};
// notes
// cận date chưa làm ,  nếu có status cận date
// khuyến mãi , nếu có deal tự thêm mã giảm giá vào tag
// nên chuyển về 1 cái , làm sau
var TagType = function(param) {
    var item = param.item, exp = param.exp, _isTooltip = param.isTooltip, isTooltip = _isTooltip === void 0 ? false : _isTooltip, _isDisplayFull = param.isDisplayFull, isDisplayFull = _isDisplayFull === void 0 ? false : _isDisplayFull, link = param.link, isLinkTagDeal = param.isLinkTagDeal;
    var ref = (0,esm/* useTranslation */.$G)("common"), translateCommon = ref.t;
    var getStyleBySlugOfTag = (0,storeGlobal/* useStore */.o)(function(state) {
        return state.getStyleBySlugOfTag;
    });
    var customerInfo = (0,context/* useAuth */.aC)().customerInfo;
    var props = {};
    if (item === sysconfig/* TAG_HANG_DAT_TRUOC */.lE && sysconfig/* REGION_MB.indexOf */.nt.indexOf("".concat(customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.provinceCode)) < 0) {
        return null;
    }
    if (item === "NEAR_EXPIRATION") {
        var date = utils/* DateTimeUtils.getFormattedDate */.IM.getFormattedDate(new Date(exp), "DD-MM-YYYY");
        var _NEAR_EXPIRATION = TagTypeProps/* default.NEAR_EXPIRATION */.Z.NEAR_EXPIRATION, code = _NEAR_EXPIRATION.code, textColor = _NEAR_EXPIRATION.textColor, backgroundColor = _NEAR_EXPIRATION.backgroundColor, url = _NEAR_EXPIRATION.url;
        props = {
            name: "".concat(translateCommon("tag.NEAR_EXPIRATION"), " ").concat(date),
            date: date,
            code: code,
            textColor: textColor,
            backgroundColor: backgroundColor,
            url: url
        };
    } else if (!isDisplayFull && (tagNoDisplayArr === null || tagNoDisplayArr === void 0 ? void 0 : tagNoDisplayArr.indexOf(item)) >= 0) {
        return null;
    } else {
        // nếu ko có option nào thì lấy theo API trả về
        var tagInfo = TagTypeProps/* default */.Z[item];
        props = tagInfo ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tagInfo), {
            isTooltip: isTooltip
        }) : getStyleBySlugOfTag(item);
        if (props && !(props === null || props === void 0 ? void 0 : props.name)) {
            var ref1;
            props.name = ((ref1 = getStyleBySlugOfTag(item)) === null || ref1 === void 0 ? void 0 : ref1.name) || "";
        }
        if (props && !(props === null || props === void 0 ? void 0 : props.slug)) {
            var ref2;
            props.slug = ((ref2 = getStyleBySlugOfTag(item)) === null || ref2 === void 0 ? void 0 : ref2.slug) || "";
        }
        if (!props) {
            return null;
        }
        if ((tagIconArr === null || tagIconArr === void 0 ? void 0 : tagIconArr.indexOf(item)) >= 0) {
            props = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                isTooltip: isTooltip
            });
        }
    }
    // translate tag số lượng có hạn
    if (item === "LIMIT") {
        props.name = translateCommon("tag.LIMIT");
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTag, (0,_object_spread/* default */.Z)({
        link: link,
        isLinkTagDeal: isLinkTagDeal
    }, props));
};
/* harmony default export */ var mocules_TagType = (TagType);


/***/ }),

/***/ 39796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ organisms_RemoveProductModal; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 12 modules
var Box = __webpack_require__(80343);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Card/Card.js
var Card = __webpack_require__(18463);
// EXTERNAL MODULE: ./src/components/atoms/index.js + 15 modules
var atoms = __webpack_require__(53316);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 6 modules
var esm = __webpack_require__(5233);
// EXTERNAL MODULE: ./src/utils/ImageFallback.js
var ImageFallback = __webpack_require__(34588);
// EXTERNAL MODULE: ./src/components/organisms/RemoveProductModal/style.module.css
var style_module = __webpack_require__(54304);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./src/components/organisms/RemoveProductModal/RemoveProductModal.js











var RemoveProductModal = /*#__PURE__*/ (0,react.memo)(function(props) {
    var ref = (0,esm/* useTranslation */.$G)("common"), translateCommon = ref.t;
    var onClose = props.onClose, onRemove = props.onRemove, visible = props.visible, className = props.className, restProps = props.restProps, product = props.product;
    var ref1 = product || {}, defaultImage = ref1.defaultImage, displayPriceFormated = ref1.displayPriceFormated;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Modal */.u_, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: className,
        open: visible
    }, restProps), {
        onClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            className: (style_module_default()).confirm_modal_wrap,
            onClick: function(e) {
                return e.stopPropagation();
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        textAlign: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (style_module_default()).modal_title,
                            children: translateCommon("confirmation")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (style_module_default()).modal_content_wrap,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (style_module_default()).modal_content,
                                "data-test": "modal-remove-product-text",
                                children: translateCommon("confirm_delete_product")
                            })
                        })
                    ]
                }),
                product && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                    className: (style_module_default()).remove_item,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (style_module_default()).remove_item_image,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackProductImage */.nZ, {
                                className: (style_module_default()).remove_item_image,
                                src: defaultImage && "".concat(defaultImage, "?size=200"),
                                fallbackSrc: defaultImage,
                                width: 80,
                                height: 80,
                                alt: product.name && product.name
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (style_module_default()).remove_item_content,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (style_module_default()).remove_item_cart_name,
                                    children: product.name && product.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (style_module_default()).remove_item_cart_price,
                                    children: displayPriceFormated
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        marginTop: "16px",
                        textAlign: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* ButtonDefaultLogin */.O2, {
                            btnType: "warning",
                            onClick: onClose,
                            "data-test": "btn-cancel-del-product-in-cart",
                            children: translateCommon("btn.no")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* ButtonDefaultLogin */.O2, {
                            onClick: function() {
                                return onRemove();
                            },
                            autoFocus: true,
                            "data-test": "btn-ok-del-product-in-cart",
                            children: translateCommon("btn.yes")
                        })
                    ]
                })
            ]
        })
    }));
});
/* harmony default export */ var RemoveProductModal_RemoveProductModal = (RemoveProductModal);

;// CONCATENATED MODULE: ./src/components/organisms/RemoveProductModal/index.js


/* harmony default export */ var organisms_RemoveProductModal = (/*#__PURE__*/react.memo(RemoveProductModal_RemoveProductModal));


/***/ }),

/***/ 11917:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * LEGACY — chỉ còn module tag cũ ở `src/components/mocules/{TagComponent,TagType}` dùng bảng này.
 *
 * Đừng thêm entry mới: style/nhãn/thứ tự của tag do CMS quyết định (xem `src/utils/TagUtils.js`
 * và `docs/product-tag-display-spec.md`). Toàn bộ entry hardcode khác đã được tắt từ
 * commit b19658a78 ("off tag hardcode", 27Jun2024) và được gỡ hẳn khi chuẩn hoá module TH.
 */ var TagTypeProps = {
    default: {
        border: "1px solid #000",
        color: "#000"
    },
    // Consumer duy nhất: src/components/mocules/TagType (chip "cận date" kèm ngày ở giỏ hàng/đơn hàng).
    NEAR_EXPIRATION: {
        code: "NEAR_EXPIRATION",
        tcode: "NEAR_EXPIRATION",
        name: "Cận date",
        textColor: "#DC5C00",
        backgroundColor: "#FFEEEF",
        index: 100,
        url: "/products"
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (TagTypeProps);


/***/ }),

/***/ 97121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var constants_Device__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32826);

var TABLET = /ipad|android 3.0|xoom|sch-i800|playbook|tablet|kindle/i;
var isTablet = function() {
    var ref;
    return TABLET.test(navigator === null || navigator === void 0 ? void 0 : (ref = navigator.userAgent) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || false;
};
var isMobileFromCtx = function(ctx) {
    var devices = ctx.req.headers["user-agent"];
    return Boolean(devices.match(constants_Device__WEBPACK_IMPORTED_MODULE_0__/* .MOBILE */ .J));
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    isTablet: isTablet,
    TABLET: TABLET,
    isMobileFromCtx: isMobileFromCtx
});


/***/ }),

/***/ 98300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var clients__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15149);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36902);
/* harmony import */ var zustand_middleware__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38597);
/* eslint-disable no-param-reassign */ 





var promotionLists = {
    data: [],
    loading: true,
    err: "",
    listSku: []
};
var useGetPromoLists = function(set, get) {
    return {
        promotionLists: promotionLists,
        getPromoLists: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(param) {
                var _skus, skus, getVoucherInfo, signal, res, _tmp, err;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _skus = param.skus, skus = _skus === void 0 ? [] : _skus, getVoucherInfo = param.getVoucherInfo, signal = param.signal;
                            set(function(state) {
                                state.promotionLists.loading = true;
                            }, false, "fetchDataPromotionLists");
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            _tmp = {};
                            return [
                                4,
                                clients__WEBPACK_IMPORTED_MODULE_0__/* .PromotionClient.getPromoLists */ .$i.getPromoLists((_tmp.skus = skus, _tmp.getVoucherInfo = getVoucherInfo, _tmp.signal = signal, _tmp))
                            ];
                        case 2:
                            res = _state.sent();
                            set(function(state) {
                                state.promotionLists.loading = false;
                                state.promotionLists.data = [
                                    (0,clients__WEBPACK_IMPORTED_MODULE_0__/* .getData */ .Yu)(res)
                                ];
                                state.promotionLists.listSku = [
                                    skus
                                ];
                            }, false, "fetchDataPromotionLists_success");
                            return [
                                3,
                                4
                            ];
                        case 3:
                            err = _state.sent();
                            set(function(state) {
                                state.promotionLists.loading = false;
                                state.promotionLists.err = err;
                            }, false, "fetchDataPromotionLists_err");
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        dataByPromoListsDetail: function() {
            var data = get().promotionLists.data;
            return data;
        },
        filterTagGift: function(sku, dataFunc, productCode) {
            if (!sku || typeof dataFunc !== "function" || !dataFunc) return false;
            var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(dataFunc() || [], 1), data = ref[0];
            var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((data === null || data === void 0 ? void 0 : data.filter(function(item) {
                if (item.sku) return item.sku === sku;
                return item.productCode === productCode;
            })) || [], 1), filterTagWithSku = ref1[0];
            if (filterTagWithSku && (filterTagWithSku === null || filterTagWithSku === void 0 ? void 0 : filterTagWithSku.hasGift)) return true;
            return false;
        }
    };
};
useGetPromoLists = (0,zustand_middleware__WEBPACK_IMPORTED_MODULE_4__/* .devtools */ .mW)(useGetPromoLists);
useGetPromoLists = (0,zustand_middleware__WEBPACK_IMPORTED_MODULE_4__/* .persist */ .tJ)(useGetPromoLists, {
    name: "gifts"
});
/* harmony default export */ __webpack_exports__["Z"] = ((0,zustand__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(useGetPromoLists));


/***/ }),

/***/ 84446:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tag_quantity":"styles_tag_quantity__1qcXT","tag":"styles_tag__eOcXj","tag_mv2":"styles_tag_mv2__MRr7b"};

/***/ }),

/***/ 26380:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root_input":"styles_root_input__vwInC","input":"styles_input__eFT_l","focus":"styles_focus__2xmTx"};

/***/ }),

/***/ 5007:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"buttons":"styles_buttons__KaOaC","button_minus":"styles_button_minus__fIaN1","button_plus":"styles_button_plus__qnrXa","icon":"styles_icon__tlEkS","plus_disabled":"styles_plus_disabled__UnzSr","button_root_minus":"styles_button_root_minus___TAIo"};

/***/ }),

/***/ 67364:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"deal_section":"styles_deal_section__HzbvE","root_process":"styles_root_process__cUfLG","count_down":"styles_count_down__1F_rA","startDate":"styles_startDate__Lmm0w","process_wrapper":"styles_process_wrapper__UEc5J","process_content":"styles_process_content__jdWkq","color_process_content":"styles_color_process_content__M34hs","bar_background":"styles_bar_background__fchhU","blur_background":"styles_blur_background__uRpvC","process_wrapper_mv2":"styles_process_wrapper_mv2__V6wHy","deal_section_mv2":"styles_deal_section_mv2__w1enq","root_process_mv2":"styles_root_process_mv2__V0ZNG","countdown_timer_mv2":"styles_countdown_timer_mv2__w_FvI","startDate_mv2":"styles_startDate_mv2__7i7ep","w_45":"styles_w_45__OpGn0","w_90":"styles_w_90__Fv8ys","w_85":"styles_w_85__zqHtb","w_100":"styles_w_100__tjkIX","w_125":"styles_w_125__5HLsL","count_down_container":"styles_count_down_container__e_XZW"};

/***/ }),

/***/ 29606:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card_wrapper":"styles_card_wrapper__4gxsU","sale_price":"styles_sale_price__3DMNb","displayPrice_wrapper":"styles_displayPrice_wrapper__x2DAD","wishlist_price_wrapper":"styles_wishlist_price_wrapper__K1Zkq","display_wishlist_price_wrapper":"styles_display_wishlist_price_wrapper__OEznG","wrap":"styles_wrap__7gf3E","display_price":"styles_display_price__WOBxy","will_buy_text":"styles_will_buy_text__DKsyn","discount_number":"styles_discount_number___dHF_","up":"styles_up__EFBSl","down":"styles_down__lj1pm","text_danger":"styles_text_danger__6MGSW","text_desc":"styles_text_desc__holJt","text_padding":"styles_text_padding__kNIxs","text_center":"styles_text_center__PdXiJ","product_action":"styles_product_action___3AJk","product_action_mobile":"styles_product_action_mobile__lZhu1","btn_del_m_wrapper":"styles_btn_del_m_wrapper__6zA4N","input_container":"styles_input_container__39PB9","input_wishlist":"styles_input_wishlist__7jmXF","gift_label":"styles_gift_label__4zVF3","border_focus_left":"styles_border_focus_left__pQ7c9","border_focus_input":"styles_border_focus_input__lTSjB","border_focus_right":"styles_border_focus_right__uXNHT","product_action_column":"styles_product_action_column__zpEDF","price_wrapper_column":"styles_price_wrapper_column__iwhIo","remove_icon":"styles_remove_icon__xgMvj","text_danger_column":"styles_text_danger_column__ZDRZO","price_wrapper":"styles_price_wrapper__i6KqQ","text_change_price":"styles_text_change_price__bF_MP","deal_price":"styles_deal_price__056ey","has_item":"styles_has_item__Kxutj","displayPrice_wrapper_mv2":"styles_displayPrice_wrapper_mv2__mAy9L","display_price_mv2":"styles_display_price_mv2__d6AYg","sale_price_mv2":"styles_sale_price_mv2__fiRYi","card_wishlist_wrapper":"styles_card_wishlist_wrapper__V6j6d","card_wishlist_mobile_wrapper":"styles_card_wishlist_mobile_wrapper__tmcPn","wishlist_input_container":"styles_wishlist_input_container__OwGke","wishlist_price":"styles_wishlist_price__eUhq5","discount_percent":"styles_discount_percent__QLs_Y","text_desc_wishlist":"styles_text_desc_wishlist__Q0B3E","text_desc_wishlist_mobile":"styles_text_desc_wishlist_mobile__4gzFe","text_quantity_wishlist":"styles_text_quantity_wishlist__Z2J4v","text_quantity_wishlist_mobile":"styles_text_quantity_wishlist_mobile__hK6Uf","wishlist_err_wrapper":"styles_wishlist_err_wrapper__wtwRF","wishlist_err_wrapper_mobile":"styles_wishlist_err_wrapper_mobile__7TKwq","remove_icon_mobile_err":"styles_remove_icon_mobile_err__yntpf","remove_icon_mobile":"styles_remove_icon_mobile__Xi1f0","fs_12":"styles_fs_12__gpf7a","discount_percent_v2":"styles_discount_percent_v2__KTOMw","p_0":"styles_p_0__zvFS8","ml_10":"styles_ml_10__jqp00","pt_55":"styles_pt_55__4WT1C","mt_5":"styles_mt_5__wlmIH","mt_15":"styles_mt_15__N72g_","mh_28":"styles_mh_28___9iqL","hidden":"styles_hidden___lLy2","btn_del_text":"styles_btn_del_text__EOeXE","card_wrapper_mv2":"styles_card_wrapper_mv2__3CqDP","contractLabel":"styles_contractLabel__R9VpQ"};

/***/ }),

/***/ 12404:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"date_tag_container":"tag_date_tag_container__bq5VK","tag_container":"tag_tag_container__Ypz6S","tag_containerv2":"tag_tag_containerv2__66m1A","normal_tag_container":"tag_normal_tag_container__Twl9u","icon_tag_container":"tag_icon_tag_container__1zOAv","nameTag":"tag_nameTag__RvjhU","nameTagMobileV2":"tag_nameTagMobileV2__E_Q_J","tag_container_mobilev2":"tag_tag_container_mobilev2__NWEoN"};

/***/ }),

/***/ 66086:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tagMobile":"style_tagMobile__C2g_u","tag_quantity":"style_tag_quantity__Jg2qT","tag_quantity_mv2":"style_tag_quantity_mv2__Cy9kK","chatMobile_moreTag":"style_chatMobile_moreTag__38lv6"};

/***/ }),

/***/ 54304:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"confirm_modal_wrap":"style_confirm_modal_wrap__bTIeR","btn":"style_btn__mnzG2","outlined_btn":"style_outlined_btn__Vbaqe","brown_btn":"style_brown_btn__tHwhV","fill_btn":"style_fill_btn__t4fmt","warning_icon":"style_warning_icon__n6NnH","text_icon":"style_text_icon__khra_","modal_title":"style_modal_title__hyVvF","modal_content":"style_modal_content__3Ut_p","remove_item":"style_remove_item__AFCYg","remove_item_content":"style_remove_item_content__vX3o4","remove_item_image":"style_remove_item_image__Xb3tU","remove_item_cart_name":"style_remove_item_cart_name__cIW_1","remove_item_cart_price":"style_remove_item_cart_price__vbIFg"};

/***/ })

}]);